import React, { useState, useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { FaFilePdf, FaHome, FaIdCard, FaFileAlt, FaChevronUp, FaChevronDown, FaQuestionCircle, FaArrowLeft, FaCheckCircle, FaShieldAlt, FaTimes, FaExclamation, FaCheck, FaInfoCircle, FaSave, FaFileImport, FaLayerGroup, FaSearch, FaEllipsisV, FaExclamationTriangle, FaEye, FaCircle, FaExchangeAlt, FaOutdent, FaTrash, FaSignOutAlt, FaGlobe, FaDesktop, FaTruck, FaEdit, FaPlusCircle, FaCogs, FaExclamationCircle, FaPlus, FaUserShield, FaUniversalAccess, FaUsers, FaFilter, FaHistory, FaUpload, FaLeaf, FaHandshake, FaSync, FaClock, FaListOl, FaBell, FaEnvelope, FaWrench, FaSortAmountDown, FaFileExport, FaBoxes, FaBars, FaChartBar, FaDownload, FaTable, FaSort, FaColumns, FaPrint, FaLightbulb, FaChartLine, FaSlidersH, FaCalendarAlt, FaMagic, FaMousePointer, FaFile, FaMoneyBill } from 'react-icons/fa';
import Sidebar from './sidebar';
import Navbar from "./navbar";
import useAuth from './useAuth';

// Tableau de bord
import tableauBordImg from '../../assets/images/manuel_utilisation/tableau-de-bord/tableau-bord.png';
import entreesImg from '../../assets/images/manuel_utilisation/tableau-de-bord/tableau-bord.png';
import sortiesImg from '../../assets/images/manuel_utilisation/tableau-de-bord/statistiques-sorties.png';
import financierImg from '../../assets/images/manuel_utilisation/tableau-de-bord/statistiques-financier.png';
import lettreVoitureImg from '../../assets/images/manuel_utilisation/tableau-de-bord/statistiques-lettres.png';
import fretImg from '../../assets/images/manuel_utilisation/tableau-de-bord/statistiques-frets.png';
import fretChargeImg from '../../assets/images/manuel_utilisation/tableau-de-bord/statistiques-frets-charges.png';
//Suivi Documents
import SuiviDocsImg from '../../assets/images/manuel_utilisation/suivi-documents/suivi-docs-liste.JPG';
import SuiviDocsBadgeRougeImg from '../../assets/images/manuel_utilisation/suivi-documents/suivi-docs-liste-badge-rouge.png';
import SuiviDocsRechercheImg from '../../assets/images/manuel_utilisation/suivi-documents/suivi-docs-rechercher.JPG';
import SuiviDocsRechercheAvanceeImg from '../../assets/images/manuel_utilisation/suivi-documents/suivi-docs-recherche-avancee.jpg';
import SuiviDocsFiltreImg from '../../assets/images/manuel_utilisation/suivi-documents/suivi-docs-filtre.png';
import SuiviDocsBtnConsulterImg from '../../assets/images/manuel_utilisation/suivi-documents/suivi-docs-btn-consulter.png';
import SuiviDocsBtnRenouvelerImg from '../../assets/images/manuel_utilisation/suivi-documents/suivi-docs-btn-renouveler.png';
import SuiviDocsConsulterImg from '../../assets/images/manuel_utilisation/suivi-documents/suivi-docs-consulter.png';
import SuiviDocsConsulterGaucheImg from '../../assets/images/manuel_utilisation/suivi-documents/suivi-docs-consulter-gauche.png';
import SuiviDocsConsulterDroiteImg from '../../assets/images/manuel_utilisation/suivi-documents/suivi-docs-consulter-droite.png';
import SuiviDocsConsulterTabsColorImg from '../../assets/images/manuel_utilisation/suivi-documents/suivi-docs-consulter-tabs-color.png';
import SuiviDocsConsulterBadgeExpireImg from '../../assets/images/manuel_utilisation/suivi-documents/suivi-docs-consulter-badge-expire.png';
import SuiviDocsConsulterCTImg from '../../assets/images/manuel_utilisation/suivi-documents/suivi-docs-consulter-CT.png';
import SuiviDocsRenouvelerImg from '../../assets/images/manuel_utilisation/suivi-documents/suivi-docs-renouveler.png';
import SuiviDocsRenouvelerGaucheImg from '../../assets/images/manuel_utilisation/suivi-documents/suivi-docs-renouveler-gauche.png';
import SuiviDocsRenouvelerDroiteImg from '../../assets/images/manuel_utilisation/suivi-documents/suivi-docs-renouveler-droite.png';
import SuiviDocsRenouvelerCTImg from '../../assets/images/manuel_utilisation/suivi-documents/suivi-docs-renouveler-CT.png';
import SuiviDocsRenouvelerConfirmerImg from '../../assets/images/manuel_utilisation/suivi-documents/suivi-docs-renouveler-confirmer.png';
import SuiviDocsRenouvelerErreurImg from '../../assets/images/manuel_utilisation/suivi-documents/suivi-docs-renouveler-message-erreur.png';
//Tours nationaux
import MenuToursNationauxImg from '../../assets/images/manuel_utilisation/tours/menu-gestion-tours-nationaux.png';
import ToursNationauxListeImg from '../../assets/images/manuel_utilisation/tours/nationaux/tours-nationaux-liste.png';
import ToursNationauxListeChargementImg from '../../assets/images/manuel_utilisation/tours/nationaux/tours-nationaux-liste-chargement.png';
import ToursNationauxActionsImg from '../../assets/images/manuel_utilisation/tours/nationaux/tours-nationaux-actions.png';
import ToursNationauxNouveauImg from '../../assets/images/manuel_utilisation/tours/nationaux/tours-nationaux-nouvelle-entree.png';
import ToursNationauxEcranImg from '../../assets/images/manuel_utilisation/tours/nationaux/tours-nationaux-ecran.png';
//Tours internationaux
import MenuToursInternationauxImg from '../../assets/images/manuel_utilisation/tours/menu-gestion-tours-internationaux.png';
import ToursInternationauxListeImg from '../../assets/images/manuel_utilisation/tours/internationaux/tours-internationaux-liste.png';
import ToursInternationauxListeChargementImg from '../../assets/images/manuel_utilisation/tours/internationaux/tours-internationaux-liste-chargement.png';
import ToursInternationauxActionsImg from '../../assets/images/manuel_utilisation/tours/internationaux/tours-internationaux-actions.png';
import ToursInternationauxNouveauImg from '../../assets/images/manuel_utilisation/tours/internationaux/tours-internationaux-nouvelle-entree.png';
import ToursInternationauxEcranImg from '../../assets/images/manuel_utilisation/tours/internationaux/tours-internationaux-ecran.png';

// Mise en file
import MiseFileEcranImg from '../../assets/images/manuel_utilisation/tours/tours-mise en file.JPG';
import SelectionOptionsParcImg from '../../assets/images/manuel_utilisation/tours/tours-selection-option-parc.JPG';
import SelectionOptionsParcCamionImg from '../../assets/images/manuel_utilisation/tours/tours-selection-option-parc-camion.jpg';
import ToursListeFIFOImg from '../../assets/images/manuel_utilisation/tours/tours-liste-fifo.JPG';
import ToursListeChargementImg from '../../assets/images/manuel_utilisation/tours/tours-liste-selection.JPG';
import ToursListeLVImg from '../../assets/images/manuel_utilisation/tours/tours-liste-L-V.JPG';
import ToursListePTImg from '../../assets/images/manuel_utilisation/tours/tours-liste-P-T.JPG';
import ToursButtonMiseFile from '../../assets/images/manuel_utilisation/tours/tours-liste-fifo-miseenfile.jpg';
import ToursMiseFile from '../../assets/images/manuel_utilisation/tours/tours-MF-1.JPG';
import ToursMiseFileValidation1 from '../../assets/images/manuel_utilisation/tours/tours-verification-vrai.JPG';
import ToursMiseFileConducteurs1 from '../../assets/images/manuel_utilisation/tours/tours-conducteurs.JPG';
import ToursMiseFileValidation2 from '../../assets/images/manuel_utilisation/tours/tours-mise-file-V-2.JPG';
import ToursMiseFileValidation3 from '../../assets/images/manuel_utilisation/tours/tours-confirmation-3.JPG';
import ToursMiseFileConfirmation from '../../assets/images/manuel_utilisation/tours/tours-confirmer.jpg';
import ToursActionFifo from '../../assets/images/manuel_utilisation/tours/tours-actions-fifo.jpg';
import ToursActionSelection from '../../assets/images/manuel_utilisation/tours/tours-actions-selection.jpg';
import ToursActionLettreVoiture from '../../assets/images/manuel_utilisation/tours/tours-actions-lettrevoiture.jpg';
import ToursActionParcTampon from '../../assets/images/manuel_utilisation/tours/tours-actions-parctampon.jpg';


//Frets
import MenuToursFretImg from '../../assets/images/manuel_utilisation/tours/menu-gestion-tours-fret.png';
import ToursFretListeImg from '../../assets/images/manuel_utilisation/tours/fret/gestion-des-frets.png';
import ToursFretQuotasImg from '../../assets/images/manuel_utilisation/tours/fret/fret-quotas.png';
import ToursFretActionsImg from '../../assets/images/manuel_utilisation/tours/fret/fret-actions.png';
import ToursFretNouveauImg from '../../assets/images/manuel_utilisation/tours/fret/fret-nouveau.png';
import ToursFretModifierImg from '../../assets/images/manuel_utilisation/tours/fret/fret-modifier.png';


import { FaCircleCheck, FaCircleExclamation, FaCircleXmark, FaRoadBarrier, FaBook, } from 'react-icons/fa6';
import { Button } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import Footer from './footer';

const ManuelUtilisation = ({ titre }) => {
    useAuth();
    const user_id = localStorage.getItem("userId");
    const navigate = useNavigate();
    useEffect(() => {
        if (user_id) {
            document.title = "Transportpro | Manuel d'utilisation";
        }
    }, [user_id]);

    const location = useLocation(); // Ajoutez cette ligne

    const [activeModule, setActiveModule] = useState(
        location.state?.fromModule || 'introduction'
    );
    const [activeSection, setActiveSection] = useState(
        location.state?.fromSection || null
    );

    const [showInfo, setShowInfo] = useState(false);
    // const [openSections, setOpenSections] = useState({});

    const [openSections, setOpenSections] = useState(() => {
        // Ouvrir par défaut le module actif
        const initialOpen = {};
        if (location.state?.fromModule) {
            initialOpen[location.state.fromModule] = true;
        } else {
            initialOpen['introduction'] = true; // ou le module par défaut
        }
        return initialOpen;
    });

    // Ouvrir automatiquement la section correspondante
    useEffect(() => {
        if (location.state?.fromModule) {
            setActiveModule(location.state.fromModule);
            setOpenSections(prev => ({
                ...prev,
                [location.state.fromModule]: true
            }));

            if (location.state?.fromSection) {
                setActiveSection(location.state.fromSection);
            }
        }
    }, [location.state]);

    // const toggleSection = (sectionId) => {
    //     setOpenSections(prev => ({
    //         ...prev,
    //         [sectionId]: !prev[sectionId]
    //     }));

    //     // Si on ouvre une section, on définit la première sous-section comme active
    //     if (!openSections[sectionId]) {
    //         const module = modules.find(m => m.id === sectionId);
    //         if (module?.sections?.length > 0) {
    //             setActiveSection(module.sections[0].id);
    //         }
    //     }
    // };
    const toggleSection = (sectionId) => {
        setOpenSections(prev => ({
            ...prev,
            [sectionId]: !prev[sectionId]
        }));

        // Garder toujours une section active, même quand on ferme
        if (!openSections[sectionId]) {
            const module = modules.find(m => m.id === sectionId);
            if (module?.sections?.length > 0) {
                setActiveSection(module.sections[0].id);
            }
        }
    };

    useEffect(() => {
        const scrollToElement = (id, offset = 20) => {
            const element = document.getElementById(id);
            if (!element) return;

            const elementPosition = element.getBoundingClientRect().top;
            const offsetPosition = elementPosition + window.pageYOffset - offset;

            // Vérifie si l'élément est déjà visible avec l'offset
            const isVisible = (
                elementPosition >= offset &&
                elementPosition <= (window.innerHeight - offset)
            );

            if (!isVisible) {
                window.scrollTo({
                    top: offsetPosition,
                    behavior: 'smooth'
                });
            }
        };

        if (activeSection) {
            setTimeout(() => {
                scrollToElement(`section-${activeSection}`);
            }, 300);
        } else if (activeModule) {
            const module = modules.find(m => m.id === activeModule);
            const sectionId = module?.sections?.length > 0 ? module.sections[0].id : null;

            setTimeout(() => {
                if (sectionId) {
                    scrollToElement(`section-${sectionId}`);
                } else {
                    scrollToElement(`module-${activeModule}`);
                }
            }, 300);
        }
    }, [activeModule, activeSection]);

    const modules = [
        {
            id: 'introduction',
            name: 'Introduction',
            icon: <FaFileAlt className="me-2" />,
            content: (
                <div className="space-y-6">
                    <h2 className="text-2xl font-bold text-blue-800 mb-6">Bienvenue dans le manuel d'utilisation de TransportPro</h2>

                    <div className="">
                        <h4 className="text-xl font-semibold text-blue-700 mb-2 flex items-center">
                            <FaInfoCircle className="mr-3 text-blue-500" />
                            À propos de ce manuel
                        </h4>
                        <p className="mb-2 text-gray-700 leading-relaxed">
                            Ce guide complet a été conçu pour vous accompagner pas à pas dans la prise en main de l'application TransportPro.
                            Il détaille l'ensemble des fonctionnalités disponibles, avec des captures d'écran annotées et des explications
                            claires pour chaque processus métier.
                        </p>
                        <p className="mb-4 text-gray-700 leading-relaxed">
                            Le manuel est organisé en modules thématiques correspondant aux principales sections de l'application.
                            Utilisez le menu de navigation à gauche pour accéder directement aux fonctionnalités qui vous intéressent.
                        </p>
                    </div>

                    <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mt-8">
                        <div className="">
                            <h4 className="text-lg font-semibold mb-2 text-gray-800 flex items-center">
                                <FaCheckCircle className="mr-2 text-green-500" />
                                Comment utiliser ce manuel
                            </h4>
                            <ul className="list-disc pl-5 space-y-2 text-gray-700">
                                <li>Cliquez sur les modules dans le menu latéral pour accéder aux différentes sections</li>
                                <li>Les icônes <FaChevronDown className="inline mx-1" /> permettent de développer les sous-sections</li>
                                <li>Les captures d'écran des processus y sont insérées</li>
                            </ul>
                        </div>

                        {/* <div className="">
                            <h4 className="text-lg font-semibold mb-3 text-gray-800 flex items-center">
                                <FaShieldAlt className="mr-2 text-blue-500" />
                                Utilisation
                            </h4>
                            <ul className="list-disc pl-5 space-y-2 text-gray-700">
                                <li>Toujours vérifier les dates d'expiration des documents</li>
                                <li>Utiliser l'import SYGFR pour gagner du temps sur les enrôlements</li>
                                <li>Consulter régulièrement le tableau de bord pour le suivi des échéances</li>
                                <li>En cas de doute, consulter l'icône <FaQuestionCircle className="inline ml-1 text-gray-500" /> d'aide contextuelle</li>
                            </ul>
                        </div> */}
                    </div>

                    <div className="">
                        <h4 className="text-xl font-semibold mb-2 text-gray-800">Structure de l'application</h4>
                        <p className="mb-2 text-gray-700">
                            TransportPro est organisé autour des modules suivants :
                        </p>
                        <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
                            <div className="ml-3">
                                <div className="flex items-center mb-2">
                                    <FaChartBar className="text-blue-500 mr-2" />
                                    <h5 className="font-bold text-blue-800">Rapport statistiques</h5>
                                </div>
                                <p className="text-sm text-gray-600">
                                    Suivi global sur les statistiques des camions , leurs entrées et leurs sorties 
                                </p>
                            </div>
                            {/* <div className="ml-3">
                                <div className="flex items-center mb-2">
                                    <FaTruck className="text-green-500 mr-2" />
                                    <h5 className="font-bold text-green-800">Enrôlement</h5>
                                </div>
                                <p className="text-sm text-gray-600">
                                    Interface complète pour l'enregistrement et la gestion des véhicules et de leurs documents.
                                </p>
                            </div>  */}
                            <div className="ml-3">
                                <div className="flex items-center mb-2">
                                    <FaFileAlt className="text-purple-500 mr-2" />
                                    <h5 className="font-bold text-purple-800">Suivi Documents</h5>
                                </div>
                                <p className="text-sm text-gray-600">
                                    Gestion proactive des échéances documentaires pour suivi du renouvelement de ces dits documents .
                                </p>
                            </div>
                            <div className="ml-3">
                                <div className="flex items-center mb-2">
                                    <FaExchangeAlt className="text-purple-500 mr-2" />
                                    <h5 className="font-bold text-purple-800">Mise en file</h5>
                                </div>
                                <p className="text-sm text-gray-600">
                                    Enregistrement FIFO des camions sur le parc, sélection des camions pour les lots de frets déclarés.
                                </p>
                            </div>

                        </div>
                    </div>
                </div>
            ),
            sections: []
        },
        {
            id: 'tableau-bord',
            name: 'Rapport et statistiques',
            icon: <FaHome className="me-2" />,
            sections: [
                {
                    id: 'dashboard-overview',
                    name: 'Vue générale',
                    content: (
                        <div className="space-y-8">
                            <h2 className="text-2xl font-bold text-blue-800 mb-4">Rapport et statistiques</h2>

                            <p className="text-gray-700 mb-6">
                                Le module de rapports et statistiques vous offre une vision complète et analysée de l'activité de transport dans les parcs.
                                Vous pouvez y suivre les indicateurs clés de performance.
                            </p>
                            {/* Image principale existante */}
                            <img src={tableauBordImg} alt="Vue d'ensemble du tableau de bord"
                                className="img-fluid mb-6 border rounded-lg shadow-md" />


                            <div className="bg-blue-50 border-l-4 border-blue-400 p-4 rounded-lg mb-6">
                                <div className="flex items-start">
                                    <FaInfoCircle className="text-blue-500 mt-1 flex-shrink-0" /> Commencez par sélectionner
                                    le type de statistique qui vous intéresse, puis affinez les résultats avec les filtres disponibles.
                                </div>
                            </div>

                            <h3 className="text-xl font-semibold mb-4 flex items-center text-blue-700">
                                <FaFilter className="mr-2 text-blue-500" />
                                Les différents types de rapports disponibles
                            </h3>

                            <div className="space-y-10">
                                {/* Rapport Véhicules Entrés */}
                                <div className="flex flex-col md:flex-row gap-6">
                                    <div className="md:w-1/2">
                                        <h4 className="text-lg font-semibold mb-1 text-blue-600">Véhicules entrés</h4>
                                        <p className="text-gray-700 mb-1">
                                            Ce rapport liste tous les véhicules ayant accédé à vos parcs sur la période sélectionnée.
                                            Vous y trouverez des informations détaillées sur chaque camion, incluant :
                                        </p>
                                        <ul className="list-disc pl-5 space-y-1 text-gray-700 mb-2">
                                            <li>La date et heure d'entrée</li>
                                            <li>Les caractéristiques du véhicule (type, immatriculation)</li>
                                            <li>Le parking d'affectation</li>
                                            <li>Le statut du droit de parking</li>
                                            <li>La charge utile transportée</li>
                                        </ul>
                                    </div>
                                    <div className="md:w-1/2">
                                        <img src={entreesImg} alt="Rapport véhicules entrés"
                                            className="img-fluid mb-6 border rounded-lg shadow-md" />
                                    </div>
                                </div>

                                {/* Rapport Véhicules Sortis */}
                                <div className="flex flex-col md:flex-row gap-6">
                                    <div className="md:w-1/2">
                                        <h4 className="text-lg font-semibold mt-4 mb-1 text-blue-600">Véhicules sortis</h4>
                                        <p className="text-gray-700 mb-1">
                                            Ce rapport recense les véhicules ayant quitté vos installations, avec des données sur :
                                        </p>
                                        <ul className="list-disc pl-5 space-y-1 text-gray-700 mb-2">
                                            <li>Les dates d'entrée et de sortie</li>
                                            <li>La durée de stationnement</li>
                                            <li>Les informations sur le véhicule et son propriétaire</li>
                                            <li>Le statut au moment de la sortie</li>
                                            <li>Les éventuelles marchandises transportées</li>
                                        </ul>
                                    </div>
                                    <div className="md:w-1/2">
                                        <img src={sortiesImg} alt="Rapport véhicules sortis"
                                            className="img-fluid mb-6 border rounded-lg shadow-md" />
                                    </div>
                                </div>

                                {/* Rapport Point Financier */}
                                <div className="flex flex-col md:flex-row gap-6">
                                    <div className="md:w-1/2">
                                        <h4 className="text-lg font-semibold mt-4 mb-1 text-blue-600">Point financier</h4>
                                        <p className="text-gray-700 mb-1">
                                            Pour le suivi des recettes liées aux droits de parking, ce rapport fournit :
                                        </p>
                                        <ul className="list-disc pl-5 space-y-1 text-gray-700 mb-2">
                                            <li>Le décompte des droits payés et impayés</li>
                                            <li>La liste détaillée des véhicules avec leur statut financier</li>
                                            <li>Des totaux par type de véhicule ou parking</li>
                                            <li>Des indicateurs de recouvrement</li>
                                        </ul>
                                    </div>
                                    <div className="md:w-1/2">
                                        <img src={financierImg} alt="Rapport point financier" className="img-fluid mb-6 border rounded-lg shadow-md" />
                                    </div>
                                </div>

                                {/* Rapport Lettres de Voiture */}
                                <div className="flex flex-col md:flex-row gap-6">
                                    <div className="md:w-1/2">
                                        <h4 className="text-lg font-semibold mt-4 mb-1 text-blue-600">Lettres de voiture</h4>
                                        <p className="text-gray-700 mb-1">
                                            Ce rapport vous permet de suivre les véhicules avec :
                                        </p>
                                        <ul className="list-disc pl-5 space-y-1 text-gray-700 mb-2">
                                            <li>Le statut de la lettre de voiture (présente/absente)</li>
                                            <li>La date de délivrance le cas échéant</li>
                                            <li>Le lien avec les véhicules concernés</li>
                                            <li>Le décompte par statut documentaire</li>
                                        </ul>
                                    </div>
                                    <div className="md:w-1/2">
                                        <img src={lettreVoitureImg} alt="Rapport lettres de voiture"
                                            className="img-fluid mb-6 border rounded-lg shadow-md" />
                                    </div>
                                </div>

                                {/* Rapport Fret */}
                                <div className="flex flex-col md:flex-row gap-6">
                                    <div className="md:w-1/2">
                                        <h4 className="text-lg font-semibold mt-4 mb-1 text-blue-600">Fret</h4>
                                        <p className="text-gray-700 mb-1">
                                            Ce rapport donne une vision des marchandises à transporter, avec :
                                        </p>
                                        <ul className="list-disc pl-5 space-y-1 text-gray-700 mb-2">
                                            <li>La référence et le type de fret</li>
                                            <li>Le trajet complet (origine-destination)</li>
                                            <li>La nature des marchandises</li>
                                            <li>Le bailleur concerné</li>
                                            <li>La charge utile totale</li>
                                            <li>Le statut actuel (en attente, assigné, etc.)</li>
                                        </ul>
                                    </div>
                                    <div className="md:w-1/2">
                                        <img src={fretImg} alt="Rapport fret" className="img-fluid mb-6 border rounded-lg shadow-md" />
                                    </div>
                                </div>

                                {/* Rapport Frets Chargés */}
                                <div className="flex flex-col md:flex-row gap-6">
                                    <div className="md:w-1/2">
                                        <h4 className="text-lg font-semibold mt-4 mb-1 text-blue-600">Frets chargés</h4>
                                        <p className="text-gray-700 mb-1">
                                            Ce rapport inclus :
                                        </p>
                                        <ul className="list-disc pl-5 space-y-1 text-gray-700 mb-2">
                                            <li>Les détails du fret transporté</li>
                                            <li>Les informations sur le véhicule affecté</li>
                                            <li>Les dates de départ et d'arrivée</li>
                                            <li>Le type de quota utilisé</li>
                                            <li>La localisation actuelle (parking)</li>
                                        </ul>
                                    </div>
                                    <div className="md:w-1/2">
                                        <img src={fretChargeImg} alt="Rapport fret chargé" className="img-fluid mb-6 border rounded-lg shadow-md" />
                                    </div>
                                </div>
                            </div>

                            <h3 className="text-xl font-semibold mt-4 mb-2 flex items-center text-blue-700">
                                <FaSlidersH className="mr-2 text-blue-500" />
                                Utilisation des filtres
                            </h3>

                            <div className="space-y-4">
                                <div>
                                    <h4 className="font-medium mb-1 text-blue-600">1. Type de statistique</h4>
                                    <p className="text-gray-700 text-sm">
                                        Sélectionnez d'abord le type de rapport souhaité (véhicules entrés, fret, etc.).
                                    </p>
                                </div>

                                <div>
                                    <h4 className="font-medium mb-1 text-blue-600">2. Période</h4>
                                    <p className="text-gray-700 text-sm">
                                        Choisissez une période prédéfinie ou personnalisée.
                                    </p>
                                </div>

                                <div>
                                    <h4 className="font-medium mb-1 text-blue-600">3. Filtres avancés</h4>
                                    <p className="text-gray-700 text-sm">
                                        Utilisez les filtres spécifiques disponibles pour chaque type de rapport.
                                    </p>
                                </div>
                            </div>

                            <h3 className="text-xl font-semibold mt-6 mb-3 flex items-center text-blue-700">
                                <FaEye className="mr-2 text-blue-500" />
                                Personnalisation
                            </h3>

                            <p className="text-gray-700 text-sm mb-2">
                                Cliquez sur "Visibilité" pour choisir les colonnes à afficher.
                            </p>

                            <h3 className="text-xl font-semibold mt-6 mb-3 flex items-center text-blue-700">
                                <FaSortAmountDown className="mr-2 text-blue-500" />
                                Tri des données
                            </h3>

                            <p className="text-gray-700 text-sm mb-2">
                                Cliquez sur les en-têtes de colonne pour trier les données.
                            </p>

                            <h3 className="text-xl font-semibold mt-6 mb-3 flex items-center text-blue-700">
                                <FaFilePdf className="mr-2 text-blue-500" />
                                Export PDF
                            </h3>

                            <p className="text-gray-700 text-sm">
                                Utilisez le bouton "Télécharger rapport" pour exporter les données affichées.
                            </p>
                        </div>
                    )
                }
            ]
        },
        // {
        //     id: 'enrolement',
        //     name: 'Enrôlement',
        //     icon: <FaTruck className="me-2" />,
        //     sections: [
        //         {
        //             id: 'nouvel-enrolement',
        //             name: 'Nouvel enrôlement',
        //             content: (
        //               <div>
        //                 <h2 className="text-lg font-bold mb-3">Enrôlement des véhicules</h2>
        //                 <p className="mb-4 text-gray-700">
        //                   Cette section vous guide dans le processus d'enrôlement d'un nouveau véhicule dans le système TransportPro.
        //                   L'enrôlement consiste à enregistrer toutes les informations et documents obligatoires relatifs à un véhicule de transport.
        //                 </p>
        //                 <p className="mb-4 text-gray-700">
        //                   Sur la page de la liste des enrolements, clisuez sur le bouton Enroler à droite
        //                 </p>
        //                 <img 
        //                   src={btnEnrolerImg}
        //                   alt="Interface de nouvel enrôlement" 
        //                   className="img-fluid mb-4 border rounded-lg shadow-sm"
        //                 />
        //                 <p className="mb-4 text-gray-700">
        //                   Vous serez redirigé sur l'interface d'enrolement
        //                 </p>
        //                 <img 
        //                   src={creerEnrolementImg}
        //                   alt="Interface de nouvel enrôlement" 
        //                   className="img-fluid mb-4 border rounded-lg shadow-sm"
        //                 />

        //                 {/* Section 1: Structure générale */}
        //                 <div className="mb-6 p-4 bg-gray-50 rounded-lg">
        //                   <h5 className="font-bold mb-3 flex items-center">
        //                     <FaLayerGroup className="mr-2 text-blue-500" />
        //                     1. Structure de la page
        //                   </h5>
        //                   <p className="mb-3 text-gray-700">
        //                     L'interface d'enrôlement est divisée en deux parties principales pour une meilleure ergonomie :
        //                   </p>
        //                   <div className="grid grid-cols-2 gap-4 mb-3">
        //                     <div>
        //                       <img 
        //                         src={structureLeftImg}
        //                         alt="Partie formulaire"
        //                         className="img-fluid mb-1 border rounded-lg shadow-sm"
        //                       />
        //                       <p className="text-sm text-center mt-1 mb-4 text-gray-600">
        //                         Partie gauche : Formulaire de saisie
        //                       </p>
        //                       <p className="text-sm text-gray-700">
        //                         Cette zone contient tous les champs à remplir, organisés par onglets thématiques correspondant aux différents documents requis.
        //                         Les champs obligatoires sont marqués d'un astérisque rouge (*).
        //                       </p>
        //                     </div>
        //                     <div>
        //                       <img 
        //                         src={structureRightImg} 
        //                         alt="Partie visualisation"
        //                         className="img-fluid mb-2 border rounded-lg shadow-sm"
        //                       />
        //                       <p className="text-sm text-center mt-1 mb-4 text-gray-600">
        //                         Partie droite : Visualisation des documents
        //                       </p>
        //                       <p className="text-sm text-gray-700">
        //                         Cet espace permet de prévisualiser les documents importés (cartes grises, assurances, etc.) avant validation.
        //                         Vous pouvez zoomer et naviguer dans les PDF directement depuis cette interface.
        //                       </p>
        //                     </div>
        //                   </div>
        //                   <ul className="list-disc pl-5 space-y-2">
        //                     <li><strong>Barre d'outils supérieure</strong> : Contient les boutons pour importer depuis SYGFR et réinitialiser le formulaire</li>
        //                     <li><strong>Onglets documentaires</strong> : Permettent un accès rapide aux différentes sections (Carte Grise, Assurance, etc.)</li>
        //                     <li><strong>Prévisualisation</strong> : Affiche dynamiquement les PDF/images des documents chargés pour vérification</li>
        //                   </ul>
        //                 </div>

        //                 {/* Section 2: Import SYGFR */}
        //                 <div className="mb-5 p-4 bg-gray-50 rounded-lg">
        //                   <h5 className="font-bold mb-3 flex items-center">
        //                     <FaFileImport className="mr-2 text-green-600" />
        //                     2. Importation depuis SYGFR
        //                   </h5>
        //                   <p className="mb-3 text-gray-700">
        //                     TransportPro permet d'importer automatiquement les données des véhicules depuis le système SYGFR (Système de Gestion des Flottes Routières),
        //                     ce qui évite une saisie manuelle fastidieuse et réduit les risques d'erreur.
        //                   </p>
        //                   <div className="grid grid-cols-3 gap-3 text-sm">
        //                     <div className="">
        //                       <div className="font-semibold text-blue-600">1. Lancement</div>
        //                       <p>Cliquez sur "Importer les données" pour accéder à la liste des véhicules enregistrés dans SYGFR</p>
        //                       <img 
        //                           src={BtnSygfrModalImg}
        //                           alt="Bouton SYGFR"
        //                           className="img-fluid mb-4 border rounded-lg shadow-sm"
        //                       />
        //                     </div>
        //                     <div className="">
        //                       <div className="font-semibold text-blue-600">2. Sélection</div>
        //                       <p>Choisissez un véhicule dans la liste proposée. Le système affiche les cartes nationale et internationale disponibles.</p>
        //                       <img 
        //                           src={ModalSygfrImg}
        //                           alt="Modal SYGFR"
        //                           className="img-fluid mb-4 border rounded-lg shadow-sm"
        //                       />
        //                     </div>
        //                     <div className="">
        //                       <div className="font-semibold text-blue-600">3. Intégration</div>
        //                       <p>Les données du véhicule sélectionné sont automatiquement importées dans les champs correspondants du formulaire.</p>
        //                       <img 
        //                           src={RemplissageSygfrImg}
        //                           alt="Modal SYGFR"
        //                           className="img-fluid mb-4 border rounded-lg shadow-sm"
        //                       />
        //                     </div>
        //                   </div>
        //                   <div className="mt-1 p-3 bg-yellow-50 border-l-4 border-yellow-400">
        //                     <FaInfoCircle className="inline mr-2 text-yellow-600" />
        //                     Le système détecte automatiquement si les cartes nationale et internationale sont jumelées et remplit les champs correspondants.
        //                     Si une carte manque, un message d'avertissement vous en informe.
        //                   </div>
        //                 </div>

        //                 {/* Section 3: Onglets documentaires */}
        //                 <div className="mb-6 p-4 bg-gray-50 rounded-lg">
        //                   <h5 className="font-bold mb-3 flex items-center">
        //                     <FaFileAlt className="mr-2 text-purple-500" />
        //                     3. Gestion des onglets
        //                   </h5>
        //                   <img 
        //                     src={tabsImg}
        //                     alt="Onglets documentaires"
        //                     className="img-fluid mb-4 border rounded-lg shadow-sm"
        //                   />
        //                   <p className="mb-3 text-gray-700">
        //                     Les 8 onglets représentent les différents documents à fournir pour un enrôlement complet. 
        //                     Chaque icône change de couleur pour indiquer l'état de complétion de la section correspondante :
        //                   </p>
        //                   <div className="d-flex justify-content-around mb-3">
        //                     <div className="text-center">
        //                         <FaCircleCheck style={{color: "green", size: 30}} className="text-green" />
        //                         <p className="text-xs mt-1">Complet</p>
        //                     </div>
        //                     <div className="text-center">
        //                         <FaCircleExclamation style={{color: "orange"}} className="text-orange" />
        //                         <p className="text-xs mt-1">Partiel</p>
        //                     </div>
        //                     <div className="text-center">
        //                         <FaCircleXmark style={{color: "black"}} className="text-dark" />
        //                         <p className="text-xs mt-1">Vide</p>
        //                     </div>
        //                   </div>
        //                   <p className="text-sm text-gray-700">
        //                     <strong>Noir</strong> : Aucun champ n'est rempli pour cet onglet<br />
        //                     <strong>Orange</strong> : Certains champs sont remplis mais il en manque<br />
        //                     <strong>Vert</strong> : Tous les champs obligatoires sont remplis
        //                   </p>
        //                 </div>

        //                 {/* Section 4: Validation */}
        //                 <div className="p-4 bg-gray-50 rounded-lg">
        //                   <h5 className="font-bold mb-3 flex items-center">
        //                     <FaShieldAlt className="mr-2 text-red-500" />
        //                     4. Validation et enregistrement
        //                   </h5>
        //                   <p className="mb-3 text-gray-700">
        //                     Avant de pouvoir enregistrer définitivement l'enrôlement, tous les onglets doivent être passés au vert,
        //                     indiquant que toutes les informations obligatoires ont été fournies.
        //                   </p>
        //                   <img 
        //                     src={tabsGreenImg}
        //                     alt="Onglets verts"
        //                     className="img-fluid mb-4 border rounded-lg shadow-sm"
        //                   />
        //                   <div className="grid grid-cols-2 gap-4">
        //                     <div>
        //                       <h6 className="font-semibold flex items-center">
        //                         <FaCheckCircle className="mr-1 text-green-500" />
        //                         Contrôles automatiques
        //                       </h6>
        //                       <p className="mb-3 text-gray-700">
        //                         Le système effectue plusieurs vérifications automatiques lors de la saisie pour garantir la cohérence des données :
        //                       </p>
        //                       <img 
        //                           src={messageErreurImg}
        //                           alt="Messages d'erreurs'"
        //                           className="img-fluid mb-4 border rounded-lg shadow-sm"
        //                       />
        //                       <ul className="list-disc pl-5 text-sm space-y-1">
        //                         <li>Format des emails et numéros de téléphone</li>
        //                         <li>Cohérence des dates (pas de date d'expiration antérieure à aujourd'hui)</li>
        //                         <li>Champs obligatoires non vides</li>
        //                         <li>Format des numéros de carte et d'immatriculation</li>
        //                       </ul>
        //                     </div>
        //                     <div>
        //                       <h6 className="font-semibold flex items-center">
        //                         <FaSave className="mr-1 text-blue-500" />
        //                         Actions finales
        //                       </h6>
        //                       <p className="mb-3 text-gray-700">
        //                         Une fois tous les onglets passés au vert, vous pouvez enregistrer l'enrôlement en cliquant sur le bouton "Enregistrer".
        //                       </p>
        //                       <p className="mb-3 text-gray-700">
        //                         Après le premier enregistrement, la page bascule en mode modification et un bouton "Terminer" apparaît.
        //                         Vous pouvez continuer à modifier les informations ou cliquer sur "Terminer" pour finaliser le processus.
        //                       </p>
        //                       <p className="mb-3 text-gray-700">
        //                         Si vous cliquez sur "Retour", vous serez redirigé vers la liste des enrôlements avec le dernier enregistrement en première position.
        //                       </p>
        //                       <img 
        //                           src={premierEnregistrementImg}
        //                           alt="Messages d'erreurs'"
        //                           className="img-fluid mb-4 border rounded-lg shadow-sm"
        //                       />
        //                     </div>
        //                   </div>
        //                 </div>
        //               </div>
        //             )
        //           },
        //           {
        //             id: 'modifier-enrolement',
        //             name: 'Modifier enrôlement',
        //             content: (
        //               <div>
        //                 <h2 className="text-lg font-bold mb-3">Modification d'un enrôlement existant</h2>
        //                 <p className="mb-4 text-gray-700">
        //                   Cette section explique comment modifier un enrôlement déjà créé mais non finalisé.
        //                   La modification permet de corriger des informations ou de compléter des documents manquants.
        //                 </p>

        //                 <div className="mb-2 p-2 bg-gray-50 rounded-lg">
        //                   <h5 className="font-bold mb-3 flex items-center">
        //                     <FaLayerGroup className="mr-2 text-blue-500" />
        //                     1. Accès à la modification
        //                   </h5>
        //                   <p className="mb-3 text-gray-700">
        //                     Pour modifier un enrôlement non terminé, suivez ces étapes depuis la liste des enrôlements :
        //                   </p>
        //                   <div className="grid grid-cols-1 gap-4 mb-3">
        //                     <div>
        //                       <p className="mb-2 font-medium">Étape 1 : Localiser l'enrôlement</p>
        //                       <p className="text-sm text-gray-700">
        //                         Dans la liste des enrôlements, repérez la ligne correspondant au véhicule que vous souhaitez modifier.
        //                         Les enrôlements non terminés sont généralement marqués d'un indicateur visuel (statut "En cours").
        //                       </p>
        //                     </div>
        //                     <div>
        //                       <p className="mb-2 font-medium">Étape 2 : Ouvrir le menu d'actions</p>
        //                       <p className="text-sm text-gray-700">
        //                         Cliquez sur les trois points (⋮) situés à la fin de la ligne.
        //                         Cela ouvre un menu contextuel avec les options disponibles pour cet enrôlement.
        //                       </p>
        //                       <img 
        //                           src={enrolementActionsImg}
        //                           alt="Menu d'actions d'enrôlement"
        //                           className="img-fluid mb-4 border rounded-lg shadow-sm"
        //                       />
        //                     </div>
        //                     <div>
        //                       <p className="mb-1 font-medium">Étape 3 : Sélectionner "Détails"</p>
        //                       <p className="text-sm text-gray-700">
        //                         Dans le menu qui apparaît, cliquez sur "Détails" pour accéder à la page de modification de l'enrôlement.
        //                         Vous serez redirigé vers une interface similaire à celle du nouvel enrôlement, mais avec les champs pré-remplis.
        //                       </p>
        //                     </div>
        //                   </div>
        //                 </div>

        //                 <div className="mb-2 p-2 bg-gray-50 rounded-lg">
        //                   <h5 className="font-bold mb-3 flex items-center">
        //                     <FaEdit className="mr-2 text-purple-500" />
        //                     2. Interface de modification
        //                   </h5>
        //                   <p className="mb-3 text-gray-700">
        //                     L'interface de modification reprend la même structure que celle du nouvel enrôlement, avec quelques différences notables :
        //                   </p>
        //                   <ul className="list-disc pl-5 space-y-2 mb-4">
        //                     <li>Tous les champs sont pré-remplis avec les informations déjà enregistrées</li>
        //                     <li>Les documents déjà importés sont visibles dans la zone de prévisualisation</li>
        //                     <li>Un bouton supplémentaire "Terminer" apparaît à côté des boutons standard</li>
        //                   </ul>
        //                   <img 
        //                       src={enrolementTerminerImg}
        //                       alt="Interface de modification avec bouton Terminer"
        //                       className="img-fluid mb-2 border rounded-lg shadow-sm"
        //                   />
        //                 </div>

        //                 <div className="p-2 bg-gray-50 rounded-lg">
        //                   <h5 className="font-bold mb-3 flex items-center">
        //                     <FaCheck className="mr-2 text-red-500" />
        //                     3. Finalisation de l'enrôlement
        //                   </h5>
        //                   <div className="grid grid-cols-1 gap-4">
        //                     <div>
        //                       <h6 className="font-semibold flex items-center">
        //                         <FaCheckCircle className="mr-1 text-green-500" />
        //                         Modification des informations
        //                       </h6>
        //                       <p className="mb-3 text-gray-700">
        //                         Vous pouvez modifier n'importe quel champ comme lors de la création initiale :
        //                       </p>
        //                       <ul className="list-disc pl-5 text-sm space-y-1">
        //                         <li>Corriger des informations erronées</li>
        //                         <li>Ajouter des documents manquants</li>
        //                         <li>Mettre à jour des dates d'expiration</li>
        //                         <li>Changer des pièces jointes</li>
        //                       </ul>
        //                     </div>
        //                     <div>
        //                       <h6 className="font-semibold flex items-center">
        //                         <FaSave className="mr-1 text-blue-500" />
        //                         Enregistrement et finalisation
        //                       </h6>
        //                       <p className="mb-3 text-gray-700">
        //                         Une fois toutes les modifications effectuées :
        //                       </p>
        //                       <ol className="list-decimal pl-5 text-sm space-y-1">
        //                         <li>Cliquez sur "Enregistrer" pour sauvegarder les changements sans terminer le processus</li>
        //                         <li>Vérifiez que tous les onglets sont passés au vert (complets)</li>
        //                         <li>Cliquez sur "Terminer" pour finaliser définitivement l'enrôlement</li>
        //                       </ol>
        //                       <div className="mt-3 p-3 bg-yellow-50 border-l-4 border-yellow-400">
        //                         <FaInfoCircle className="inline mr-2 text-yellow-600" />
        //                         Une fois terminé, l'enrôlement ne pourra plus être modifié directement. Pour apporter des modifications ultérieures,
        //                         vous devrez passer par une procédure spécifique de mise à jour.
        //                       </div>
        //                     </div>
        //                   </div>
        //                 </div>
        //               </div>
        //             )
        //           },
        //           {
        //             id: 'liste-enrolement',
        //             name: 'Liste des enrôlements',
        //             content: (
        //                 <div>
        //                     <h2 className="text-lg font-bold mb-2">Gestion de la liste des enrôlements</h2>
        //                     <p className="text-gray-700">
        //                         Cette interface vous permet de visualiser, rechercher et gérer tous les véhicules enrôlés dans le système.
        //                         Vous pouvez filtrer les résultats, modifier ou terminer un enrôlement en cours.
        //                     </p>

        //                     <div className="mb-2 p-2 bg-gray-50 rounded-lg">
        //                         <h5 className="font-bold mb-3 flex items-center">
        //                             <FaLayerGroup className="mr-2 text-blue-500" />
        //                             1. Structure de la page
        //                         </h5>
        //                         <img
        //                             src={premierEnregistrementImg}
        //                             alt="Interface liste des enrôlements"
        //                             className="img-fluid mb-4 border rounded-lg shadow-sm"
        //                         />
        //                         <p className="mb-3 text-gray-700">
        //                             La liste des enrôlements présente les informations principales sous forme de tableau avec :
        //                         </p>
        //                         <ul className="list-disc pl-5 space-y-2">
        //                             <li><strong>Barre de recherche</strong> : Permet de filtrer les résultats par immatriculation, propriétaire, etc.</li>
        //                             <li><strong>Pagination</strong> : Navigation entre les pages de résultats</li>
        //                             <li><strong>Colonnes triables</strong> : Cliquez sur les en-têtes pour trier par ordre croissant/décroissant</li>
        //                             <li><strong>Statut visuel</strong> : Indique si l'enrôlement est "En cours" ou "Terminé"</li>
        //                             <li><strong>Menu d'actions</strong> : Options disponibles pour chaque véhicule</li>
        //                         </ul>
        //                     </div>

        //                     <div className="mb-2 p-2 bg-gray-50 rounded-lg">
        //                         <h5 className="font-bold mb-3 flex items-center">
        //                             <FaFileAlt className="mr-2 text-purple-500" />
        //                             2. Fonctionnalités clés
        //                         </h5>
        //                         <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        //                             <div>
        //                                 <h6 className="font-semibold flex items-center">
        //                                     <FaSearch className="mr-1 text-blue-500" />
        //                                     Recherche et filtrage
        //                                 </h6>
        //                                 <p className="mb-3 text-gray-700">
        //                                     Utilisez le champ de recherche en haut à droite pour trouver rapidement un véhicule par :
        //                                 </p>
        //                                 <ul className="list-disc pl-5 text-sm space-y-1">
        //                                     <li>Numéro d'immatriculation</li>
        //                                     <li>Nom du propriétaire</li>
        //                                     <li>Téléphone</li>
        //                                     <li>Référence de carte transport</li>
        //                                 </ul>
        //                                 <img
        //                                     src={enrolementRechercheImg}
        //                                     alt="Interface liste des enrôlements"
        //                                     className="img-fluid mb-4 border rounded-lg shadow-sm"
        //                                 />
        //                             </div>
        //                             <div>
        //                                 <h6 className="font-semibold flex items-center">
        //                                     <FaEllipsisV className="mr-1 text-green-600" />
        //                                     Actions disponibles
        //                                 </h6>
        //                                 <p className="mb-3 text-gray-700">
        //                                     Pour chaque véhicule, cliquez sur les trois points (⋮) pour accéder aux options :
        //                                 </p>
        //                                 <ul className="list-disc pl-5 text-sm space-y-1">
        //                                     <li><strong>Détails</strong> : Consulter toutes les informations</li>
        //                                     <li><strong>Supprimer</strong> : Mettre en corbeille l'enrôlement</li>
        //                                     <li><strong>Terminer</strong> : Finaliser un enrôlement en cours</li>
        //                                 </ul>
        //                                 <img
        //                                     src={enrolementActionsImg}
        //                                     alt="Interface liste des enrôlements actions"
        //                                     className="img-fluid mb-4 border rounded-lg shadow-sm"
        //                                 />
        //                                 <p className="mb-3 text-gray-700">
        //                                     <strong>Terminer</strong> disparait lorsque l'enrolement est finalisé et que le statut passe à "enrôler"
        //                                 </p>
        //                                 <img
        //                                     src={enrolerActions2Img}
        //                                     alt="Interface liste des enrôlements actions"
        //                                     className="img-fluid mb-4 border rounded-lg shadow-sm"
        //                                 />
        //                             </div>
        //                         </div>
        //                     </div>

        //                     <div className="p-4 bg-gray-50 rounded-lg">
        //                         <h5 className="font-bold mb-3 flex items-center">
        //                             <FaTruck className="mr-2 text-red-500" />
        //                             3. Statuts et suite
        //                         </h5>
        //                         <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        //                             <div>
        //                                 <h6 className="font-semibold flex items-center">
        //                                     <FaCheck className="mr-1 text-green-500" />
        //                                     Gestion des statuts
        //                                 </h6>
        //                                 <p className="mb-3 text-gray-700">
        //                                     Comprenez bien la signification des différents statuts :
        //                                 </p>
        //                                 <ul className="list-disc pl-5 text-sm space-y-1">
        //                                     <li><span className="text-blue-600 font-medium">En cours</span> : Enrôlement non finalisé, modifications possibles</li>
        //                                     <li><span className="text-green-600 font-medium">Enrôlé</span> : Processus terminé, visible dans le suivi documents</li>
        //                                 </ul>
        //                             </div>
        //                             <div>
        //                                 <h6 className="font-semibold flex items-center">
        //                                     <FaExclamation className="mr-1 text-yellow-500" />
        //                                     Info
        //                                 </h6>
        //                                 <p className="mb-3 text-gray-700">
        //                                     Une fois un enrôlement terminé :
        //                                 </p>
        //                                 <ol className="list-decimal pl-5 text-sm space-y-1">
        //                                     <li>Vous ne pouvez plus le modifier directement</li>
        //                                     <li>Il apparaîtra dans le module de suivi des documents</li>
        //                                     <li>Les échéances seront suivies automatiquement</li>
        //                                 </ol>
        //                             </div>
        //                         </div>
        //                     </div>
        //                 </div>
        //             )
        //         }
        //     ]
        //   },
        {
            id: 'suivi-documents',
            name: 'Suivi Documents',
            icon: <FaFileAlt className="me-2" />,
            sections: [
                {
                    id: 'liste-vehicules-pieces',
                    name: 'Liste des pièces',
                    content: (
                        <div>
                            <h2 className="text-lg font-bold mb-3">Suivi des documents des véhicules</h2>
                            <p className="mb-1 text-gray-700">
                                Cette interface centrale vous permet de suivre l'état de validité de tous les documents obligatoires
                                pour chaque véhicule enrôlé sur Sygfr. Le système met en évidence les documents expirés ou sur le point d'expirer
                                pour une gestion proactive des renouvellements.
                            </p>

                            <div className="mb-2 p-2 bg-gray-50 rounded-lg">
                                <h5 className="font-bold mb-3 flex items-center">
                                    <FaLayerGroup className="mr-2 text-blue-500" />
                                    1. Structure et fonctionnalités principales
                                </h5>
                                <img
                                    src={SuiviDocsImg}
                                    alt="Interface suivi des documents"
                                    className="img-fluid mb-4 border rounded-lg shadow-sm"
                                />
                                <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                                    <div>
                                        <h6 className="font-semibold flex items-center">
                                            <FaSearch className="mr-1 text-blue-500" />
                                            Outils de recherche
                                        </h6>
                                        <ul className="list-disc pl-5 text-sm space-y-1">
                                            <li><strong>Recherche rapide</strong> : Par immatriculation, propriétaire ou téléphone</li>
                                            <img
                                                src={SuiviDocsRechercheImg}
                                                alt="Interface suivi des documents rechercher"
                                                className="img-fluid mt-2 mb-4 border rounded-lg shadow-sm"
                                            />
                                            <li><strong className="mb-1">Recherche avancée</strong> : Filtres par période d'expiration, immatriculation, etc.</li>
                                            <img
                                                src={SuiviDocsRechercheAvanceeImg}
                                                alt="Interface suivi des documents recherche avancée"
                                                className="img-fluid mt-2 mb-4 border rounded-lg shadow-sm"
                                            />
                                            <li><strong className="mb-1">Filtres temporels</strong> : Documents expirés, à 7/15/30 jours</li>
                                            <img
                                                src={SuiviDocsFiltreImg}
                                                alt="Interface suivi des documents filtre"
                                                className="img-fluid mt-2 mb-4 border rounded-lg shadow-sm"
                                            />
                                        </ul>
                                    </div>
                                </div>
                            </div>

                            <div className="mb-2 p-2 bg-gray-50 rounded-lg">
                                <h5 className="font-bold mb-3 flex items-center">
                                    <FaInfoCircle className="mr-2 text-green-600" />
                                    2. Codes couleurs et statuts
                                </h5>
                                <div className="grid grid-cols-1 md:grid-cols-3 gap-4 mb-4">
                                    <div className="text-center">
                                        <span className="badge bg-primary">Valide</span>
                                        <p className="text-sm mt-2 text-gray-700">
                                            Le document est valide (plus de 30 jours avant expiration)
                                        </p>
                                    </div>
                                    <div className="text-center">
                                        <span className="badge bg-warning">30 jours</span>
                                        <p className="text-sm mt-2 text-gray-700">
                                            Le document expire dans moins de 30 jours (renouvellement nécessaire)
                                        </p>
                                    </div>
                                    <div className="text-center">
                                        <span className="badge bg-danger">Expiré</span>
                                        <p className="text-sm mt-2 text-gray-700">
                                            Le document est expiré (renouvellement urgent requis)
                                        </p>
                                    </div>
                                </div>
                                <p className="text-sm text-gray-700">
                                    Les couleurs s'affichent dynamiquement en fonction de la date du jour et des dates d'expiration enregistrées.
                                </p>
                            </div>

                            {/* <div className="mb-2 p-2 bg-gray-50 rounded-lg">
                                <h5 className="font-bold mb-3 flex items-center">
                                    <FaEllipsisV className="mr-2 text-red-500" />
                                    3. Actions disponibles
                                </h5>
                                <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                                    <div>
                                        <h6 className="font-semibold flex items-center">
                                            <FaSearch className="mr-1 text-green-600" />
                                            Consulter les pièces
                                        </h6>
                                        <p className="mb-3 text-gray-700">
                                            Pour consulter les versions actuelles des pièces d'un véhicules :
                                        </p>
                                        <ol className="list-decimal pl-5 text-sm space-y-1">
                                            <li>Cliquez sur les trois points (⋮) en fin de ligne</li>
                                            <li>Sélectionnez "Consulter" dans le menu</li>
                                            <li>Vous serez redirigé vers la page de consultation</li>
                                        </ol>
                                            <img
                                                src={SuiviDocsBtnConsulterImg}
                                                alt="Interface suivi des documents filtre"
                                                className="img-fluid mb-4 border rounded-lg shadow-sm"
                                            />
                                    </div>
                                    <div>
                                        <h6 className="font-semibold flex items-center">
                                            <FaFileImport className="mr-1 text-blue-500" />
                                            Renouveler une pièces
                                        </h6>
                                        <p className="mb-3 text-gray-700">
                                            Pour renouveler une pièce expirée vous devez d'abord avoir au moins un document expiré au niveau de la ligne pour que cette option apparaisse :
                                        </p>
                                        <ol className="list-decimal pl-5 text-sm space-y-1">
                                            <li>Cliquez sur les trois points (⋮) en fin de ligne</li>
                                            <li>Sélectionnez "Renouveler" dans le menu </li>
                                            <li>Et vous serez redirigé sur la page de renouvellement des pièces</li>
                                        </ol>
                                            <img
                                                src={SuiviDocsBtnRenouvelerImg}
                                                alt="Interface suivi des documents filtre"
                                                className="img-fluid mb-4 border rounded-lg shadow-sm"
                                            />
                                    </div>
                                </div>
                            </div> */}
                        </div>
                    )
                },
                // {
                //     id: 'consulter-pieces',
                //     name: 'Consulter les pièces',
                //     content: (
                //         <div>
                //             <h2 className="text-lg font-bold mb-3">Consultation des pièces d'un véhicule</h2>
                //             <p className="mb-1 text-gray-700">
                //                 Cette section explique comment consulter les différentes pièces documentaires associées à un véhicule enrôlé dans le système.
                //             </p>

                //             <div className="mb-2 p-2 bg-gray-50 rounded-lg">
                //                 <h5 className="font-bold mb-3 flex items-center">
                //                     <FaLayerGroup className="mr-2 text-blue-500" />
                //                     1. Accès à la consultation
                //                 </h5>
                //                 <p className="mb-3 text-gray-700">
                //                     Pour consulter les pièces d'un véhicule, suivez ces étapes depuis la liste des documents suivis :
                //                 </p>
                //                 <div className="grid grid-cols-1 gap-4 mb-3">
                //                     <div>
                //                         <p className="mb-2 font-medium">Étape 1 : Localiser le véhicule</p>
                //                         <p className="text-sm text-gray-700">
                //                             Dans la liste des documents, repérez la ligne correspondant au véhicule que vous souhaitez consulter.
                //                             Vous pouvez utiliser les filtres ou la recherche pour trouver rapidement un véhicule spécifique.
                //                         </p>
                //                         <img 
                //                             src={SuiviDocsImg}
                //                             alt="Liste des documents suivis"
                //                             className="img-fluid mb-4 border rounded-lg shadow-sm"
                //                         />
                //                     </div>
                //                     <div>
                //                         <p className="mb-2 font-medium">Étape 2 : Ouvrir le menu d'actions</p>
                //                         <p className="text-sm text-gray-700">
                //                             Cliquez sur les trois points (⋮) situés à la fin de la ligne.
                //                             Cela ouvre un menu contextuel avec les options disponibles.
                //                         </p>
                //                         <img 
                //                             src={SuiviDocsBtnConsulterImg}
                //                             alt="Menu d'actions avec option Consulter"
                //                             className="img-fluid mb-4 border rounded-lg shadow-sm"
                //                         />
                //                     </div>
                //                     <div>
                //                         <p className="mb-2 font-medium">Étape 3 : Sélectionner "Consulter"</p>
                //                         <p className="text-sm text-gray-700">
                //                             Dans le menu qui apparaît, cliquez sur "Consulter" pour accéder à la page de visualisation des pièces.
                //                         </p>
                //                     </div>
                //                 </div>
                //             </div>

                //             <div className="mb-2 p-2 bg-gray-50 rounded-lg">
                //                 <h5 className="font-bold mb-3 flex items-center">
                //                     <FaFileAlt className="mr-2 text-purple-500" />
                //                     2. Interface de consultation
                //                 </h5>
                //                 <p className="mb-3 text-gray-700">
                //                     L'interface de consultation est divisée en deux parties principales :
                //                 </p>
                //                         <img 
                //                             src={SuiviDocsConsulterImg}
                //                             alt="Page Consulter"
                //                             className="img-fluid mb-4 border rounded-lg shadow-sm"
                //                         />

                //                 <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mb-4">
                //                     <div>
                //                         <h6 className="font-semibold flex items-center">
                //                             <FaFileAlt className="mr-1 text-blue-500" />
                //                             Partie gauche : Onglets documentaires
                //                         </h6>
                //                         <img 
                //                             src={SuiviDocsConsulterGaucheImg}
                //                             alt="Page Consulter"
                //                             className="img-fluid mb-4 border rounded-lg shadow-sm"
                //                         />
                //                         <p className="mb-3 text-gray-700">
                //                             Cette zone contient tous les onglets correspondant aux différents documents du véhicule.
                //                             Les icônes changent de couleur pour indiquer l'état des documents :
                //                         </p>
                //                         <ul className="list-disc pl-5 text-sm space-y-1">
                //                             <li><span className="text-dark">Vert</span> : Document valide</li>
                //                             {/* <li><span className="text-warning">Orange</span> : Document à renouveler (expiration proche)</li> */}
                //                             <li><span className="text-dark">Rouge</span> : Document expiré</li>
                //                             <li><span className="text-dark">Noir</span> : Document non renseigné</li>
                //                         </ul>
                //                         <img 
                //                             src={SuiviDocsConsulterTabsColorImg}
                //                             alt="Page Consulter"
                //                             className="img-fluid mb-4 border rounded-lg shadow-sm"
                //                         />
                //                     </div>
                //                     <div>
                //                         <h6 className="font-semibold flex items-center">
                //                             <FaSearch className="mr-1 text-green-600" />
                //                             Partie droite : Visualisation des documents
                //                         </h6>
                //                         <img 
                //                             src={SuiviDocsConsulterDroiteImg}
                //                             alt="Page Consulter"
                //                             className="img-fluid mb-4 border rounded-lg shadow-sm"
                //                         />
                //                         <p className="mb-3 text-gray-700">
                //                             Cet espace permet de visualiser les documents PDF ou images associés à l'onglet sélectionné.
                //                             Vous pouvez zoomer et naviguer dans les documents directement depuis cette interface.
                //                         </p>
                //                     </div>
                //                 </div>

                //                 <div className="mt-3 p-3 bg-yellow-50 border-l-4 border-yellow-400">
                //                     <FaInfoCircle className="inline mr-2 text-yellow-600" />
                //                     Pour la carte transport, l'interface distingue clairement les cartes nationale et internationale,
                //                     avec des indicateurs d'expiration séparés pour chacune.
                //                 </div>
                //                         <img 
                //                             src={SuiviDocsConsulterCTImg}
                //                             alt="Page Consulter"
                //                             className="img-fluid mb-3 border rounded-lg shadow-sm"
                //                         />
                //             </div>

                //             <div className="p-2 bg-gray-50 rounded-lg">
                //                 <h5 className="font-bold mb-3 flex items-center">
                //                     <FaFile className="mr-2 text-red-500" />
                //                     3. Fonctionnalités clés
                //                 </h5>
                //                 <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                //                     <div>
                //                         <h6 className="font-semibold flex items-center">
                //                             <FaEye className="mr-1 text-primary" />
                //                             Visualisation des documents
                //                         </h6>
                //                         <p className="mb-3 text-gray-700">
                //                             Cliquez sur chaque onglet pour afficher le document correspondant dans la zone de visualisation.
                //                             Les documents sont affichés sous forme d'images ou de PDF selon leur format d'origine.
                //                         </p>
                //                     </div>
                //                     <div>
                //                         <h6 className="font-semibold flex items-center">
                //                             <FaExclamationTriangle className="mr-1 text-warning" />
                //                             Alertes visuelles
                //                         </h6>
                //                         <p className="mb-3 text-gray-700">
                //                             Le système met en évidence les documents expirés ou sur le point d'expirer :
                //                         </p>
                //                         <ul className="list-disc pl-5 text-sm space-y-1">
                //                             <li>Badge rouge pour les documents expirés</li>
                //                             {/* <li>Badge orange pour les documents à 30 jours ou moins de l'expiration</li> */}
                //                         </ul>
                //                         <img 
                //                             src={SuiviDocsConsulterBadgeExpireImg}
                //                             alt="Page Consulter"
                //                             className="img-fluid mb-4 border rounded-lg shadow-sm"
                //                         />
                //                     </div>
                //                 </div>
                //             </div>
                //         </div>
                //     )
                // },
                // {
                //     id: 'renouveler-pieces',
                //     name: 'Renouveler pièces',
                //     content: (
                //         <div>
                //             <h2 className="text-lg font-bold mb-3">Renouvellement des pièces expirées</h2>
                //             <p className="mb-1 text-gray-700">
                //                 Cette section explique comment renouveler les documents expirés ou sur le point d'expirer pour un véhicule enrôlé dans le système.
                //             </p>

                //             <div className="mb-2 p-2 bg-gray-50 rounded-lg">
                //                 <h5 className="font-bold mb-3 flex items-center">
                //                     <FaLayerGroup className="mr-2 text-blue-500" />
                //                     1. Accès au renouvellement
                //                 </h5>
                //                 <p className="mb-3 text-gray-700">
                //                     Pour renouveler les pièces d'un véhicule, suivez ces étapes depuis la liste des documents suivis :
                //                 </p>
                //                 <div className="grid grid-cols-1 gap-4 mb-3">
                //                     <div>
                //                         <p className="mb-2 font-medium">Étape 1 : Localiser le véhicule</p>
                //                         <p className="text-sm text-gray-700">
                //                             Dans la liste des documents, repérez la ligne correspondant au véhicule dont vous souhaitez renouveler les pièces.
                //                             Les véhicules avec des documents expirés sont marqués d'un indicateur visuel (badge rouge).
                //                         </p>
                //                         <img 
                //                             src={SuiviDocsBadgeRougeImg}
                //                             alt="Liste des documents avec indicateurs d'expiration"
                //                             className="img-fluid mb-4 border rounded-lg shadow-sm"
                //                         />
                //                     </div>
                //                     <div>
                //                         <p className="mb-2 font-medium">Étape 2 : Ouvrir le menu d'actions</p>
                //                         <p className="text-sm text-gray-700">
                //                             Cliquez sur les trois points (⋮) situés à la fin de la ligne. Cette option n'apparaît que si le véhicule a au moins un document expiré.
                //                         </p>
                //                         <img 
                //                             src={SuiviDocsBtnRenouvelerImg}
                //                             alt="Menu d'actions avec option Renouveler"
                //                             className="img-fluid mb-4 border rounded-lg shadow-sm"
                //                         />
                //                     </div>
                //                     <div>
                //                         <p className="mb-2 font-medium">Étape 3 : Sélectionner "Renouveler"</p>
                //                         <p className="text-sm text-gray-700">
                //                             Dans le menu qui apparaît, cliquez sur "Renouveler" pour accéder à la page de renouvellement des pièces.
                //                         </p>
                //                     </div>
                //                 </div>
                //             </div>

                //             <div className="mb-2 p-2 bg-gray-50 rounded-lg">
                //                 <h5 className="font-bold mb-3 flex items-center">
                //                     <FaFileAlt className="mr-2 text-purple-500" />
                //                     2. Interface de renouvellement
                //                 </h5>
                //                 <p className="mb-3 text-gray-700">
                //                     L'interface de renouvellement est similaire à celle de consultation, avec quelques différences importantes :
                //                 </p>
                //                 <img 
                //                     src={SuiviDocsRenouvelerImg}
                //                     alt="Interface de renouvellement des pièces"
                //                     className="img-fluid mb-4 border rounded-lg shadow-sm"
                //                 />

                //                 <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mb-4">
                //                     <div>
                //                         <h6 className="font-semibold flex items-center">
                //                             <FaFileAlt className="mr-1 text-blue-500" />
                //                             Partie gauche : Onglets documentaires
                //                         </h6>
                //                         <p className="mb-3 text-gray-700">
                //                             Les onglets sont organisés comme dans l'interface de consultation, mais avec des indicateurs spécifiques :
                //                         </p>
                //                         <img
                //                             src={SuiviDocsRenouvelerGaucheImg}
                //                             alt="Interface de renouvellement des pièces"
                //                             className="img-fluid mb-4 border rounded-lg shadow-sm"
                //                         />
                //                         <ul className="list-disc pl-5 text-sm space-y-1">
                //                             <li>Les icônes des documents expirés sont en rouge</li>
                //                             <li>Seuls les champs des documents expirés sont modifiables</li>
                //                             <li>Les champs des documents non expirés sont désactivés</li>
                //                         </ul>
                //                     </div>
                //                     <div>
                //                         <h6 className="font-semibold flex items-center">
                //                             <FaSearch className="mr-1 text-green-600" />
                //                             Partie droite : Visualisation et import
                //                         </h6>
                //                         <img
                //                             src={SuiviDocsRenouvelerDroiteImg}
                //                             alt="Interface de renouvellement des pièces"
                //                             className="img-fluid mb-4 border rounded-lg shadow-sm"
                //                         />
                //                         <p className="mb-3 text-gray-700">
                //                             Cette zone permet de visualiser les documents existants et d'importer les nouvelles versions :
                //                         </p>
                //                         <ul className="list-disc pl-5 text-sm space-y-1">
                //                             <li>Bouton "Choisir un fichier" disponible pour les documents expirés</li>
                //                             <li>Prévisualisation des nouveaux documents importés</li>
                //                             <li>Affichage des documents existants pour référence</li>
                //                         </ul>
                //                     </div>
                //                 </div>

                //                 <div className="mt-3 p-3 bg-yellow-50 border-l-4 border-yellow-400">
                //                     <FaInfoCircle className="inline mr-2 text-yellow-600" />
                //                     Pour la carte transport, l'interface distingue clairement les cartes nationale et internationale,
                //                     avec des boutons d'import séparés pour chaque type.
                //                 </div>
                //                         <img
                //                             src={SuiviDocsRenouvelerCTImg}
                //                             alt="Interface de renouvellement des pièces"
                //                             className="img-fluid mb-2 border rounded-lg shadow-sm"
                //                         />
                //             </div>

                //             <div className="mb-2 p-2 bg-gray-50 rounded-lg">
                //                 <h5 className="font-bold mb-3 flex items-center">
                //                     <FaEllipsisV className="mr-2 text-red-500" />
                //                     3. Processus de renouvellement
                //                 </h5>
                //                 <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                //                     <div>
                //                         <h6 className="font-semibold flex items-center">
                //                             <FaCheckCircle className="mr-1 text-green-500" />
                //                             Sélection des pièces à renouveler
                //                         </h6>
                //                         <p className="mb-3 text-gray-700">
                //                             Lorsque vous cliquez sur "Enregistrer", une fenêtre flottante apparaît pour sélectionner les pièces à renouveler :
                //                         </p>
                //                         <ul className="list-disc pl-5 text-sm space-y-1">
                //                             <li>Seules les pièces expirées sont proposées</li>
                //                             <li>Pour la carte transport, vous pouvez choisir entre nationale et internationale</li>
                //                             <li>Vous devez sélectionner au moins une pièce pour continuer</li>
                //                         </ul>
                //                         <img
                //                             src={SuiviDocsRenouvelerConfirmerImg}
                //                             alt="Interface de renouvellement des pièces"
                //                             className="img-fluid mb-4 border rounded-lg shadow-sm"
                //                         />
                //                     </div>
                //                     <div>
                //                         <h6 className="font-semibold flex items-center">
                //                             <FaSave className="mr-1 text-blue-500" />
                //                             Validation finale
                //                         </h6>
                //                         <p className="mb-3 text-gray-700">
                //                             Après confirmation, le système effectue plusieurs vérifications :
                //                         </p>
                //                         <ol className="list-decimal pl-5 text-sm space-y-1">
                //                             <li>Tous les champs obligatoires doivent être remplis</li>
                //                             <li>Les dates d'expiration doivent être dans le futur</li>
                //                             <li>Les fichiers doivent être dans un format valide (PDF, JPG, PNG)</li>
                //                         </ol>
                //                     </div>
                //                 </div>
                //             </div>

                //             <div className="p-4 bg-gray-50 rounded-lg">
                //                 <h5 className="font-bold mb-3 flex items-center">
                //                     <FaShieldAlt className="mr-2 text-red-500" />
                //                     4. Après le renouvellement
                //                 </h5>
                //                 <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                //                     <div>
                //                         <h6 className="font-semibold flex items-center">
                //                             <FaCheck className="mr-1 text-primary" />
                //                             Succès
                //                         </h6>
                //                         <p className="mb-3 text-gray-700">
                //                             Si le renouvellement est réussi :
                //                         </p>
                //                         <ul className="list-disc pl-5 text-sm space-y-1">
                //                             <li>Un message de confirmation s'affiche</li>
                //                             <li>Les nouvelles dates d'expiration sont enregistrées</li>
                //                             <li>Les nouveaux fichiers remplacent les anciens</li>
                //                             <li>Le statut des documents passe à "valide" au niveau de la ligne du véhicule concerné dans la liste des véhicules</li>
                //                         </ul>
                //                     </div>
                //                     <div>
                //                         <h6 className="font-semibold flex items-center">
                //                             <FaExclamationTriangle className="mr-1 text-warning" />
                //                             En cas d'erreur
                //                         </h6>
                //                         <p className="mb-3 text-gray-700">
                //                             Si des problèmes sont détectés :
                //                         </p>
                //                         <ul className="list-disc pl-5 text-sm space-y-1">
                //                             <li>Un message d'erreur détaillé s'affiche</li>
                //                             <li>Les champs problématiques sont mis en évidence</li>
                //                             <li>Vous pouvez corriger les erreurs et réessayer</li>
                //                         </ul>
                //                         <img
                //                             src={SuiviDocsRenouvelerErreurImg}
                //                             alt="Interface de renouvellement des pièces"
                //                             className="img-fluid mb-4 border rounded-lg shadow-sm"
                //                         />
                //                     </div>
                //                 </div>
                //             </div>
                //         </div>
                //     )
                // }
            ]
        },
        {
            id: 'gestion-tours',
            name: 'Mise en file',
            icon: <FaExchangeAlt className="me-2" />,
            sections: [
                {
                    id: 'tour-national',
                    name: 'Fret domestique',
                    content: (
                        <div>
                            <h2 className="text-lg font-bold mb-3">Mise en file sur Parc</h2>
                            <img
                                src={MiseFileEcranImg}
                                alt="Menu tours nationaux"
                                className="img-fluid mb-4 border rounded-lg shadow-sm"
                            />
                            <p className="mb-4 text-gray-700">
                                Ce module permet de gérer les camions disponibles pour le transport national ou international de marchandises.
                                Il suit le principe FIFO (First In, First Out) et permet d'organiser les camions en attente de chargement.
                                En tant qu'utilisateur, si vous avez cet interface cela veut dire que vous avez les accès nécéssaires et vous avez été affecter à un parc.                        
                            </p>

                            <div className="mb-2 p-2 bg-gray-50 rounded-lg">
                                <h5 className="font-bold mb-3 flex items-center">
                                    {/* <FaLayerGroup className="mr-2 text-blue-500" /> */}
                                    I. Sélection des options
                                </h5>
                                <p className="mb-3 text-gray-700">
                                    cliquez sur le parc sur lequel on vous a affecter
                                </p>
                                <img
                                    src={SelectionOptionsParcImg}
                                    alt="Interface de tours nationaux"
                                    className="img-fluid mt-1 mb-4 border rounded-lg shadow-sm"
                                />
                                <h5 className="font-bold mb-3 flex items-center">
                                    {/* <FaLayerGroup className="mr-2 text-blue-500" /> */}
                                    I-1. Interface des opérations de mise en file
                                </h5>
                                <p className="mb-3 text-gray-700">
                                    Cliquez sur <strong>Camion</strong>
                                </p>
                                <img
                                    src={SelectionOptionsParcCamionImg}
                                    alt="Interface de tours nationaux"
                                    className="img-fluid mt-1 mb-4 border rounded-lg shadow-sm"
                                />
                                <ul className="list-disc pl-5 space-y-2">
                                    <li>
                                        <strong>Liste FIFO</strong> : Permet de visualiser les camions enregistrés dans le parc selon leur ordre d’arrivée (principe premier arrivé, premier servi) avec les informations complètes. C'est l'interface de l'opérateur d'entrée sur le parc, il est celui qui s'occupe de la mise en file.
                                        <img
                                            src={ToursListeFIFOImg}
                                            alt="Interface de tours nationaux"
                                            className="img-fluid mt-2 mb-4 border rounded-lg shadow-sm"
                                        />
                                    </li>
                                    <li>
                                        <strong>Liste de sélection</strong> : Permet de visualiser les camions sélectionnés pour enlever un fret donné.  C'est l'interface du superviseur sur le parc, il consulte également la liste FIFO et la lettre de voiture
                                        <img
                                            src={ToursListeChargementImg}
                                            alt="Liste des camions en chargement"
                                            className="img-fluid mt-1 mb-4 border rounded-lg shadow-sm"
                                        />
                                    </li>
                                    <li>
                                        <strong>Liste des lettres de voitures</strong> : Permet de visualiser les camions sélectionnés pour un fret et dont la lettre de voiture a été déjà délivré.  C'est l'interface de l'opérateur de sortie sur le parc, c'est lui qui autorise la sortie des camions du parc du regroupement vers le parc tampon
                                        <img
                                            src={ToursListeLVImg}
                                            alt="Liste des camions en chargement"
                                            className="img-fluid mt-1 mb-4 border rounded-lg shadow-sm"
                                        />
                                    </li>
                                    {/* <li>
                                        <strong>Liste des parcs tampons</strong> : Affiche les camions en partance pour le parc tampon. C'est l'interface de l'opérateur sur le parc tampon
                                        <img
                                            src={ToursListePTImg}
                                            alt="Liste des camions en chargement"
                                            className="img-fluid mt-1 mb-4 border rounded-lg shadow-sm"
                                        />
                                    </li> */}
                                </ul>
                            </div>

                            <div className="mb-2 p-2 bg-gray-50 rounded-lg">
                                <h5 className="font-bold mb-3 flex items-center">
                                    <FaFileAlt className="mr-2 text-purple-500" />
                                    I-2. Effectuer une mise en file sur le parc
                                </h5>
                                <p className="mb-3 text-gray-700">
                                    Pour ajouter un nouveau camion à la file d'attente :
                                </p>
                                <ol className="list-decimal pl-5 space-y-1 mb-2">
                                    <li>Cliquez sur le bouton "Mise en file" dans l'onglet Liste FIFO</li>
                                    <img
                                        src={ToursButtonMiseFile}
                                        alt="Formulaire d'enregistrement"
                                        className="img-fluid mt-2 mb-4 border rounded-lg shadow-sm"
                                    />
                                    <li>Remplissez le formulaire avec les informations requises en passant par 3 validations</li>
                                    <li><strong>Validation 1</strong> : Vérifier les informations du camion voulant se mettre en file
                                        <ul className="list-disc pl-5 mt-1">
                                            <li>Sélectionnez le genre de véhicule au niveau de <strong>Atellage</strong> (Articulé ou Non articulé)</li>
                                            <li>Si le genre de véhicule est <strong>Articulé</strong> alors renseigner deux références de carte de transport</li>
                                            <li>Entrez le numéro de référence de la carte transport du véhicule</li>
                                            <li>Sinon dans le cas ou le véhicule est du genre <strong>Non articulé</strong>, renseigner une seule référence de carte de transport</li>
                                            <li>Cliquer sur le bouton "Vérifier les cartes"</li>
                                            <img
                                                src={ToursMiseFile}
                                                alt="Formulaire d'enregistrement"
                                                className="img-fluid mt-2 mb-4 border rounded-lg shadow-sm"
                                            />
                                            <li>Si la vérification a été un succès vous verrez les informations concernant le camion s'afficher pour conformité avec les papiers qui vous sont présentés</li>
                                            <li>De meme le bouton "Suivant" s'active pour passer à la seconde validation</li>
                                            <img
                                                src={ToursMiseFileValidation1}
                                                alt="Formulaire d'enregistrement"
                                                className="img-fluid mt-2 mb-4 border rounded-lg shadow-sm"
                                            />
                                        </ul>
                                    </li>
                                    
                                    <li><strong>Validation 2</strong> : Vérifier les informations du conducteur et de son assistant voulant se mettre en file
                                        <ul className="list-disc pl-5 mt-1">
                                            <li>Entrez le numéro du permis du conducteur principal pour vérification</li>
                                            <li>Entrez le numéro du permis ou de la pièce d'identité de l'assistant du conducteur pour vérification</li>
                                            <li>Cliquer sur le bouton "Vérifier les conducteurs"</li>
                                            <img
                                                src={ToursMiseFileConducteurs1}
                                                alt="Formulaire d'enregistrement"
                                                className="img-fluid mt-2 mb-4 border rounded-lg shadow-sm"
                                            />
                                            <li>Si la vérification a été un succès vous verrez les informations concernant le conducteur et son assistant s'afficher pour conformité avec les papiers qui vous sont présentés</li>
                                            <li>De meme le bouton "Suivant" s'active pour passer à la troisième validation qui est la confirmation</li>
                                            <img
                                                src={ToursMiseFileValidation2}
                                                alt="Formulaire d'enregistrement"
                                                className="img-fluid mt-2 mb-4 border rounded-lg shadow-sm"
                                            />
                                        </ul>
                                    </li>
                                    <li><strong>Validation 3</strong> : Complèter les informations néccessaires pour finaliser la mise en file 
                                        <ul className="list-disc pl-5 mt-1">
                                            <li>Sélectionnez la catégorie de fret que le véhicule désire charger</li>
                                            <li>Renseigner la charge utile constaté sur la carte grise</li>
                                            <li>Renseigner le nombre d'essieux constaté sur le véhicule</li>
                                            <li>Renseigner l'organisation professionelle auquelle appartient le proprietaire du camion ou non</li>
                                            <img
                                                src={ToursMiseFileValidation3}
                                                alt="Formulaire d'enregistrement"
                                                className="img-fluid mt-2 mb-4 border rounded-lg shadow-sm"
                                            />
                                            <li>Cliquer sur le bouton "Confirmer la mise en ligne"</li>
                                            <img
                                                src={ToursMiseFileConfirmation}
                                                alt="Formulaire d'enregistrement"
                                                className="img-fluid mt-2 mb-4 border rounded-lg shadow-sm"
                                            />
                                        </ul>
                                    </li>
                                </ol>
                                <div className="mt-2 p-2 bg-yellow-50 border-l-4 border-yellow-400">
                                    <FaInfoCircle className="inline mr-2 text-yellow-600" />
                                    <strong>Il est important de s'assurer que les informations reçues sur la plateforme lors de la vérification sont conformes à ceux physiquement présentés par le conducteur pour la mise en file. C'est la responsabilité de l'opérateur d'entrée </strong>
                                </div>
                            </div>

                            {/* <div className="mb-2 p-2 bg-gray-50 rounded-lg">
                                <h5 className="font-bold mb-3 flex items-center">
                                    <FaSearch className="mr-2 text-green-600" />
                                    3. Gestion des statuts
                                </h5>
                                <p className="mb-3 text-gray-700">
                                    Les camions peuvent avoir différents statuts :
                                </p>
                                <div className="grid grid-cols-1 md:grid-cols-5 gap-4 mb-4">
                                    <div className="text-center">
                                        <span className="badge badge-secondary">Disponible</span>
                                        <p className="text-sm mt-2 text-gray-700">
                                            Le camion est enregistré dans le système des tours et est prêt pour le transport de fret
                                        </p>
                                    </div>
                                    <div className="text-center">
                                        <span className="badge badge-warning">En panne</span>
                                        <p className="text-sm mt-2 text-gray-700">
                                            Le camion, auparavant disponible, est temporairement indisponible ou hors service.
                                        </p>
                                    </div>
                                    <div className="text-center">
                                        <span className="badge bg-success">Chargement de marchandises</span>
                                        <p className="text-sm mt-2 text-gray-700">
                                            Le camion est actuellement en cours de chargement pour le transport du fret.
                                        </p>
                                    </div>
                                    <div className="text-center">
                                        <span className="badge badge-primary">Transport de marchandises</span>
                                        <p className="text-sm mt-2 text-gray-700">
                                            Le camion a quitté le parc de regroupement après avoir été sélectionné .
                                        </p>
                                    </div>
                                    <div className="text-center">
                                        <span className="badge bg-danger">Sorti de rang</span>
                                        <p className="text-sm mt-2 text-gray-700">
                                            Le camion a renoncé au tour auquel il s’était initialement inscrit.
                                        </p>
                                    </div>
                                </div>
                                <p className="text-sm text-gray-700">
                                    Vous pouvez changer le statut d'un camion via le menu d'actions (trois points).
                                </p>
                            </div>                         */}

                            <div className="mb-2 p-2 bg-gray-50 rounded-lg">
                                <h5 className="font-bold mb-3 flex items-center">
                                    <FaEllipsisV className="mr-2 text-red-500" />
                                    4. Actions disponibles
                                </h5>
                                <p>4-1. Actions disponibles sur la liste FIFO</p>
                                {/* <img
                                    src={ToursActionFifo}
                                    alt="Menu des actions"
                                    className="img-fluid mb-4 border rounded-lg shadow-sm"
                                /> */}
                                <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                                    <div>
                                        <h4 className="font-semibold flex items-center">
                                            {/* <FaExchangeAlt className="mr-1 text-green-500" /> */}
                                            Changer statut
                                        </h4>
                                        <p className="mb-3 text-gray-700">
                                            Permet de modifier l’état du camion <strong>Disponible</strong> ou <strong>En panne</strong>. Sert à refléter la situation en temps réel. 
                                            Le camion reste dans la liste, n’est pas sélectionné lors d’une déclaration de fret.
                                        </p>
                                    </div>
                                    <div>
                                        <h4 className="font-semibold flex items-center">
                                            {/* <FaSignOutAlt className="mr-1 text-blue-500" /> */}
                                            Sortir de rang
                                        </h4>
                                        <p className="mb-3 text-gray-700">
                                            Permet de retirer un camion de la file FIFO. Le camion perd sa position dans la file.
                                        </p>
                                    </div>
                                    <div>
                                        <h4 className="font-semibold flex items-center">
                                            {/* <FaSignOutAlt className="mr-1 text-blue-500" /> */}
                                            Conducteur indisponible
                                        </h4>
                                        <p className="mb-3 text-gray-700">
                                            Permet de signaler que le chauffeur n’est pas disponible. Le camion reste dans la liste, 
                                            n’est pas sélectionné lors d’une déclaration de fret. L'état du camion est mofifier également:
                                            <strong>Disponible</strong> ou <strong>Conducteur indisponible</strong>
                                        </p>
                                    </div>
                                    <div>
                                        <h4 className="font-semibold flex items-center">
                                            {/* <FaSignOutAlt className="mr-1 text-blue-500" /> */}
                                            Remplacer chauffeur
                                        </h4>
                                        <p className="mb-3 text-gray-700">
                                            Permet de changer le conducteur associé au camion. Le camion reste dans la file, mais avec un nouveau chauffeur.
                                        </p>
                                    </div>
                                    <div>
                                        <h4 className="font-semibold flex items-center">
                                            {/* <FaSignOutAlt className="mr-1 text-blue-500" /> */}
                                            Bailleurs affiliés
                                        </h4>
                                        <p className="mb-3 text-gray-700">
                                            Cette action permet de voir la liste des bailleurs liés à un transporteur qui est le propriétaire du camion
                                        </p>
                                    </div>
                                </div>

                                <p>4-2. Actions disponibles sur la liste de sélection</p>
                                {/* <img
                                    src={ToursActionSelection}
                                    alt="Menu des actions"
                                    className="img-fluid mb-4 border rounded-lg shadow-sm"
                                /> */}
                                <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                                    <div>
                                        <h4 className="font-semibold flex items-center">
                                            {/* <FaExchangeAlt className="mr-1 text-green-500" /> */}
                                            Sortir de rang
                                        </h4>
                                        <p className="mb-3 text-gray-700">
                                            Permet de retirer un camion de la file FIFO. Le camion perd sa position dans la file.
                                        </p>
                                    </div>
                                    {/* <div>
                                        <h6 className="font-semibold flex items-center">
                                            <FaSignOutAlt className="mr-1 text-blue-500" />
                                            Sortir de rang
                                        </h6>
                                        <p className="mb-3 text-gray-700">
                                            Retire définitivement un camion qui perds son tour de la file d'attente.
                                        </p>
                                    </div> */}
                                </div>

                                <p>4-3. Actions disponibles sur la liste de lettre de voiture</p>
                                {/* <img
                                    src={ToursActionLettreVoiture}
                                    alt="Menu des actions"
                                    className="img-fluid mb-4 border rounded-lg shadow-sm"
                                /> */}
                                <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                                    <div>
                                        <h4 className="font-semibold flex items-center">
                                            {/* <FaExchangeAlt className="mr-1 text-green-500" /> */}
                                            Faire sortir du parc
                                        </h4>
                                        <p className="mb-3 text-gray-700">
                                            Permet d’enregistrer la sortie du camion du parc de regroupement vers le parc tampon.
                                        </p>
                                    </div>
                                    <div>
                                        <h4 className="font-semibold flex items-center">
                                            {/* <FaSignOutAlt className="mr-1 text-blue-500" /> */}
                                            Voir lettre
                                        </h4>
                                        <p className="mb-3 text-gray-700">
                                            Affiche le document de la lettre de voiture provenant de SYGFR
                                        </p>
                                    </div>
                                    <div>
                                        <h4 className="font-semibold flex items-center">
                                            {/* <FaSignOutAlt className="mr-1 text-blue-500" /> */}
                                            Voir Contrat
                                        </h4>
                                        <p className="mb-3 text-gray-700">
                                            Affiche le document de contrat de transport généré par TransportPro
                                        </p>
                                    </div>
                                </div>

                                {/* <p>4-4. Actions disponibles sur la liste de Parc tampon</p>
                                <img
                                    src={ToursActionParcTampon}
                                    alt="Menu des actions"
                                    className="img-fluid mb-4 border rounded-lg shadow-sm"
                                />
                                <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                                    <div>
                                        <h6 className="font-semibold flex items-center">
                                            <FaExchangeAlt className="mr-1 text-green-500" />
                                            Changer statut
                                        </h6>
                                        <p className="mb-3 text-gray-700">
                                            Permet de faire passer un camion d'un statut <strong>Disponible</strong> à <strong>En panne</strong> et de <strong>En panne</strong> à <strong>Disponible</strong>.
                                            C'est dans le cas ou un camion est momentanément indisponible pour etre sélectionner pour un fret
                                        </p>
                                    </div>
                                    <div>
                                        <h6 className="font-semibold flex items-center">
                                            <FaSignOutAlt className="mr-1 text-blue-500" />
                                            Sortir de rang
                                        </h6>
                                        <p className="mb-3 text-gray-700">
                                            Retire définitivement un camion qui perds son tour de la file d'attente.
                                        </p>
                                    </div>
                                </div> */}
                            </div>

                            <div className="mb-2 p-2 bg-gray-50 rounded-lg">
                                <h5 className="font-bold mb-3 flex items-center">
                                    <FaOutdent className="mr-2 text-primary" />
                                    6. Processus de sortie
                                </h5>
                                <p className="mb-3 text-gray-700">
                                    Pour faire sortir un camion :
                                </p>
                                <ol className="list-decimal pl-5 space-y-1 mb-2">
                                    <li>Sélectionnez "faire sortir du parc" dans le menu d'actions</li>
                                    <li>Importez la lettre de voiture (format PDF ou image)</li>
                                    <li>Confirmez la sortie</li>
                                </ol>
                                {/* <div className="mt-2 p-2 bg-yellow-50 border-l-4 border-yellow-400">
                                    <FaInfoCircle className="inline mr-2 text-yellow-600" />
                                    Le droit de chargement doit être marqué comme "Payé" avant de pouvoir sortir un camion.
                                </div> */}
                            </div>

                            <div className="p-2 bg-gray-50 rounded-lg">
                                <h5 className="font-bold mb-3 flex items-center">
                                    <FaDesktop className="mr-2 text-red-500" />
                                    7. Écrans d'affichage
                                </h5>
                                <p className="mb-3 text-gray-700">
                                    TransportPro propose des écrans dédiés pour visualiser les camions :
                                </p>
                                <ul className="list-disc pl-5 mb-3">
                                    <li>Écran principal des tours nationaux</li>
                                </ul>
                                <p className="text-sm text-gray-700">
                                    L'écran s'ouvre dans un nouvel onglet via le bouton en haut de la page de gestion.
                                </p>
                                <img
                                    src={ToursNationauxEcranImg}
                                    alt="Écran d'affichage"
                                    className="img-fluid mb-4 border rounded-lg shadow-sm"
                                />
                            </div>
                        </div>
                    )
                },
                // {
                //     id: 'tour-international',
                //     name: 'Fret en transit',
                //     content: (
                //         <div>
                //             <h2 className="text-lg font-bold mb-3">Gestion des tours internationaux</h2>
                //             <img
                //                 src={MenuToursInternationauxImg}
                //                 alt="Menu tours internationaux"
                //                 className="img-fluid mb-4 border rounded-lg shadow-sm"
                //             />
                //             <p className="mb-4 text-gray-700">
                //                 Ce module permet de gérer les camions effectuant des transports transfrontaliers.
                //                 Il suit le même principe FIFO que les tours nationaux mais avec des spécificités
                //                 liées aux documents et procédures douanières internationales.
                //             </p>

                //             <div className="mb-6 p-4 bg-gray-50 rounded-lg">
                //                 <h5 className="font-bold mb-3 flex items-center">
                //                     <FaLayerGroup className="mr-2 text-blue-500" />
                //                     1. Interface principale
                //                 </h5>
                //                 <p className="mb-3 text-gray-700">
                //                     L'interface des tours internationaux présente deux onglets principaux :
                //                 </p>
                //                 <ul className="list-disc pl-5 space-y-2">
                //                     <li>
                //                         <strong>Liste FIFO</strong> : Affiche les camions dans l'ordre d'arrivée avec leurs informations complètes
                //                         <img
                //                             src={ToursInternationauxListeImg}
                //                             alt="Interface de tours internationaux"
                //                             className="img-fluid mt-1 mb-4 border rounded-lg shadow-sm"
                //                         />
                //                     </li>
                //                     <li>
                //                         <strong>Liste de chargement</strong> : Montre les camions actuellement en cours de chargement avec leurs informations de fret
                //                         <img
                //                             src={ToursInternationauxListeChargementImg}
                //                             alt="Liste des camions en chargement"
                //                             className="img-fluid mt-1 mb-4 border rounded-lg shadow-sm"
                //                         />
                //                     </li>
                //                 </ul>
                //                 <p className="mt-3 text-sm text-gray-700">
                //                     Vous pouvez basculer entre ces deux vues à l'aide des onglets en haut de la page.
                //                 </p>
                //             </div>

                //             <div className="mb-6 p-4 bg-gray-50 rounded-lg">
                //                 <h5 className="font-bold mb-3 flex items-center">
                //                     <FaFileAlt className="mr-2 text-purple-500" />
                //                     2. Enregistrement d'un nouveau camion
                //                 </h5>
                //                 <p className="mb-3 text-gray-700">
                //                     Pour ajouter un nouveau camion international à la file d'attente :
                //                 </p>
                //                 <ol className="list-decimal pl-5 space-y-1 mb-4">
                //                     <li>Cliquez sur le bouton "Enregistrer" dans l'onglet Liste FIFO</li>
                //                     <li>Remplissez le formulaire avec les informations requises :
                //                         <ul className="list-disc pl-5 mt-1">
                //                             <li>Sélectionnez le genre de véhicule (Articulé ou Non articulé)</li>
                //                             <li>Choisissez la tête et la queue pour les véhicules articulés</li>
                //                             <li>Sélectionnez l'immatriculation pour les véhicules non articulés</li>
                //                             <li>Indiquez le conducteur assigné</li>
                //                             <li>Spécifiez le parc de stationnement (doit être de type "international")</li>
                //                             <li>Entrez la charge utile du véhicule</li>
                //                         </ul>
                //                     </li>
                //                     <img
                //                         src={ToursInternationauxNouveauImg}
                //                         alt="Formulaire d'enregistrement"
                //                         className="img-fluid mb-4 border rounded-lg shadow-sm"
                //                     />
                //                     <li>Cliquez sur "Prévisualiser" pour vérifier les informations</li>
                //                     <li>Confirmez l'enregistrement</li>
                //                 </ol>
                //                 <div className="mt-3 p-3 bg-yellow-50 border-l-4 border-yellow-400">
                //                     <FaInfoCircle className="inline mr-2 text-yellow-600" />
                //                     Les camions internationaux doivent obligatoirement être affectés à un parc de type "international".
                //                 </div>
                //             </div>

                //             <div className="mb-6 p-4 bg-gray-50 rounded-lg">
                //                 <h5 className="font-bold mb-3 flex items-center">
                //                     <FaSearch className="mr-2 text-green-600" />
                //                     3. Gestion des statuts
                //                 </h5>
                //                 <p className="mb-3 text-gray-700">
                //                     Les camions internationaux peuvent avoir différents statuts :
                //                 </p>
                //                 <div className="grid grid-cols-1 md:grid-cols-5 gap-4 mb-4">
                //                     <div className="text-center">
                //                         <span className="badge badge-secondary">Disponible</span>
                //                         <p className="text-sm mt-2 text-gray-700">
                //                             Camion enregistré et prêt pour le transport international
                //                         </p>
                //                     </div>
                //                     <div className="text-center">
                //                         <span className="badge badge-warning">En panne</span>
                //                         <p className="text-sm mt-2 text-gray-700">
                //                             Camion temporairement hors service
                //                         </p>
                //                     </div>
                //                     <div className="text-center">
                //                         <span className="badge bg-success">Chargement</span>
                //                         <p className="text-sm mt-2 text-gray-700">
                //                             Camion en cours de chargement pour l'export
                //                         </p>
                //                     </div>
                //                     <div className="text-center">
                //                         <span className="badge badge-primary">Sorti</span>
                //                         <p className="text-sm mt-2 text-gray-700">
                //                             Camion parti avec sa marchandise vers l'étranger
                //                         </p>
                //                     </div>
                //                     <div className="text-center">
                //                         <span className="badge bg-danger">Sorti de rang</span>
                //                         <p className="text-sm mt-2 text-gray-700">
                //                             Conducteur temporairement indisponible
                //                         </p>
                //                     </div>
                //                 </div>
                //                 <p className="text-sm text-gray-700">
                //                     Vous pouvez changer le statut d'un camion via le menu d'actions (trois points).
                //                 </p>
                //             </div>

                //             <div className="mb-6 p-4 bg-gray-50 rounded-lg">
                //                 <h5 className="font-bold mb-3 flex items-center">
                //                     <FaShieldAlt className="mr-2 text-red-500" />
                //                     4. Gestion des documents et paiements
                //                 </h5>
                //                 <p className="mb-3 text-gray-700">
                //                     Le système permet de gérer les documents et paiements spécifiques aux transports internationaux :
                //                 </p>
                //                 <div className="grid grid-cols-1 md:grid-cols-3 gap-4 mb-4">
                //                     <div className="text-center">
                //                         <span className="badge badge-secondary">Non payé</span>
                //                         <p className="text-sm mt-2 text-gray-700">
                //                             Droit de tour non réglé
                //                         </p>
                //                     </div>
                //                     <div className="text-center">
                //                         <span className="badge badge-success">Payé</span>
                //                         <p className="text-sm mt-2 text-gray-700">
                //                             Droit de tour réglé
                //                         </p>
                //                     </div>
                //                     {/* <div className="text-center">
                //                         <span className="badge badge-secondary">Documents manquants</span>
                //                         <p className="text-sm mt-2 text-gray-700">
                //                             Documents douaniers incomplets
                //                         </p>
                //                     </div> */}
                //                 </div>
                //                 <p className="text-sm text-gray-700">
                //                     Ces statuts peuvent être modifiés via le menu d'actions (trois points).
                //                 </p>
                //             </div>

                //             <div className="mb-6 p-4 bg-gray-50 rounded-lg">
                //                 <h5 className="font-bold mb-3 flex items-center">
                //                     <FaEllipsisV className="mr-2 text-red-500" />
                //                     5. Actions disponibles
                //                 </h5>
                //                 <img
                //                     src={ToursInternationauxActionsImg}
                //                     alt="Menu des actions"
                //                     className="img-fluid mb-4 border rounded-lg shadow-sm"
                //                 />
                //                 <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                //                     <div>
                //                         <h6 className="font-semibold flex items-center">
                //                             <FaExchangeAlt className="mr-1 text-green-500" />
                //                             Changer statut
                //                         </h6>
                //                         <p className="mb-3 text-gray-700">
                //                             Permet de faire passer un camion d'un statut à un autre selon le workflow international.
                //                         </p>
                //                     </div>
                //                     <div>
                //                         <h6 className="font-semibold flex items-center">
                //                             <FaSignOutAlt className="mr-1 text-blue-500" />
                //                             Sortir de rang
                //                         </h6>
                //                         <p className="mb-3 text-gray-700">
                //                             Retire temporairement un camion de la file d'attente internationale.
                //                         </p>
                //                     </div>
                //                     <div>
                //                         <h6 className="font-semibold flex items-center">
                //                             <FaCheckCircle className="mr-1 text-green-500" />
                //                             Gérer paiements
                //                         </h6>
                //                         <p className="mb-3 text-gray-700">
                //                             Marquer les droits de tour comme payés ou non payés.
                //                         </p>
                //                     </div>
                //                     <div>
                //                         <h6 className="font-semibold flex items-center">
                //                             <FaEye className="mr-1 text-orange-500" />
                //                             Voir lettre
                //                         </h6>
                //                         <p className="mb-3 text-gray-700">
                //                             Prévisualiser la lettre de voiture internationale associée au camion.
                //                         </p>
                //                     </div>
                //                     <div>
                //                         <h6 className="font-semibold flex items-center">
                //                             <FaOutdent className="mr-1 text-primary" />
                //                             Sortir
                //                         </h6>
                //                         <p className="mb-3 text-gray-700">
                //                             Marquer un camion comme étant parti avec sa marchandise vers l'étranger.
                //                         </p>
                //                     </div>
                //                     <div>
                //                         <h6 className="font-semibold flex items-center">
                //                             <FaTrash className="mr-1 text-red-500" />
                //                             Supprimer
                //                         </h6>
                //                         <p className="mb-3 text-gray-700">
                //                             Retire définitivement un camion de la file d'attente internationale.
                //                         </p>
                //                     </div>
                //                 </div>
                //             </div>

                //             <div className="mb-6 p-4 bg-gray-50 rounded-lg">
                //                 <h5 className="font-bold mb-3 flex items-center">
                //                     <FaOutdent className="mr-2 text-primary" />
                //                     6. Processus de sortie internationale
                //                 </h5>
                //                 <p className="mb-3 text-gray-700">
                //                     Pour faire sortir un camion international :
                //                 </p>
                //                 <ol className="list-decimal pl-5 space-y-1 mb-4">
                //                     <li>Sélectionnez "Sortir" dans le menu d'actions</li>
                //                     <li>Importez la lettre de voiture internationale (format PDF ou image)</li>
                //                     <li>Vérifiez que tous les documents douaniers sont en règle</li>
                //                     <li>Confirmez la sortie</li>
                //                 </ol>
                //                 <div className="mt-3 p-3 bg-yellow-50 border-l-4 border-yellow-400">
                //                     <FaInfoCircle className="inline mr-2 text-yellow-600" />
                //                     Le droit de chargement doit être marqué comme "Payé" avant de pouvoir sortir un camion international.
                //                 </div>
                //             </div>

                //             <div className="p-4 bg-gray-50 rounded-lg">
                //                 <h5 className="font-bold mb-3 flex items-center">
                //                     <FaDesktop className="mr-2 text-red-500" />
                //                     7. Écrans d'affichage spécifiques
                //                 </h5>
                //                 <p className="mb-3 text-gray-700">
                //                     TransportPro propose des écrans dédiés pour visualiser les camions internationaux :
                //                 </p>
                //                 <ul className="list-disc pl-5 mb-3">
                //                     <li>Écran principal des tours internationaux</li>
                //                     <li>Écran par pays de destination</li>
                //                 </ul>
                //                 <p className="text-sm text-gray-700">
                //                     Ces écrans s'ouvrent dans un nouvel onglet via le bouton "Ecran" en haut de la page de gestion.
                //                 </p>
                //                 <img
                //                     src={ToursInternationauxEcranImg}
                //                     alt="Écran d'affichage international"
                //                     className="img-fluid mb-4 border rounded-lg shadow-sm"
                //                 />
                //             </div>

                //             <div className="p-4 bg-gray-50 rounded-lg mt-4">
                //                 <h5 className="font-bold mb-3 flex items-center">
                //                     <FaGlobe className="mr-2 text-blue-500" />
                //                     8. Spécificités internationales
                //                 </h5>
                //                 <p className="mb-3 text-gray-700">
                //                     Les fonctionnalités spécifiques aux transports internationaux incluent :
                //                 </p>
                //                 <ul className="list-disc pl-5 space-y-2">
                //                     <li>Gestion des documents douaniers</li>
                //                     <li>Suivi par pays de destination</li>
                //                     <li>Vérification des documents obligatoires avant sortie</li>
                //                     <li>Statistiques spécifiques aux flux internationaux</li>
                //                 </ul>
                //                 <div className="mt-3 p-3 bg-blue-50 border-l-4 border-blue-400">
                //                     <FaInfoCircle className="inline mr-2 text-blue-600" />
                //                     Les camions internationaux sont visibles dans un écran dédié organisé par pays de destination.
                //                 </div>
                //             </div>
                //         </div>
                //     )
                // },

                // {
                //     id: 'gestion-frets',
                //     name: 'Gestion des frets',
                //     content: (
                //         <div className="space-y-6">
                //             <h2 className="text-2xl font-bold text-blue-800 mb-4">Gestion des Déclarations de Fret</h2>
                //             <img
                //                 src={MenuToursFretImg}
                //                 alt="Menu principal de gestion des frets"
                //                 className="img-fluid mb-4 border rounded-lg shadow-sm"
                //             />
                //             <p className="mb-4 text-gray-700">
                //                 Ce module permet d'enregistrer et de suivre les marchandises transportées lors des tours nationaux et internationaux.
                //                 Il comprend quatre interfaces principales avec des fonctionnalités complètes pour gérer le cycle de vie des déclarations.
                //             </p>

                //             {/* Section 1: Liste des Déclarations */}
                //             <div>
                //                 <h5 className="font-bold text-xl mb-4 flex items-center text-blue-700">
                //                     <FaLayerGroup className="mr-3 text-blue-500" />
                //                     1. Interface Liste des Déclarations
                //                 </h5>
                //                 <img
                //                     src={ToursFretListeImg}
                //                     alt="Liste des déclarations de fret"
                //                     className="img-fluid mb-4 border rounded-lg shadow-sm"
                //                 />

                //                 <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-4">
                //                     <div>
                //                         <h6 className="font-semibold mb-2 flex items-center">
                //                             <FaSearch className="mr-2 text-blue-500" />
                //                             Fonctionnalités Principales
                //                         </h6>
                //                         <ul className="list-disc pl-5 space-y-2 text-gray-700">
                //                             <li><strong>Recherche avancée</strong> : Filtrage par tous les champs du tableau</li>
                //                             <li><strong>Tri des colonnes</strong> : Cliquez sur les en-têtes pour trier</li>
                //                             <li><strong>Vue responsive</strong> : Adapté pour mobile et desktop</li>
                //                             <li><strong>Visualisation des statuts</strong> :
                //                                 <ul className="list-disc pl-5 mt-1 space-y-1">
                //                                     <li><span className="badge badge-secondary">En attente réservation</span> : Statut 'en attente' - Non réservé</li>
                //                                     <li><span className="badge badge-warning">En attente assignation</span> : Statut 'reservee' - Réservé mais non assigné</li>
                //                                     <li><span className="badge bg-success">Assignation en cours</span> : Statut 'En cours' - Assignation partielle</li>
                //                                     <li><span className="badge bg-primary">Assignation terminée</span> : Statut 'selection terminee' - Tous camions assignés</li>
                //                                 </ul>
                //                             </li>
                //                             <li className="mt-1"><strong>Calcul des quotas restants</strong> : Affichage du nombre de camions manquants en cliquant sur l'option "Détails" dans les actions.</li>
                //                             <img
                //                                 src={ToursFretQuotasImg}
                //                                 alt="Liste des déclarations de fret"
                //                                 className="img-fluid mt-2 mb-4 border rounded-lg shadow-sm"
                //                             />
                //                         </ul>
                //                     </div>

                //                     <div>
                //                         <h6 className="font-semibold mb-2 flex items-center">
                //                             <FaEllipsisV className="mr-2 text-green-600" />
                //                             Actions Disponibles
                //                         </h6>
                //                         <div className="space-y-3">
                //                             <div className="p-1 bg-white rounded">
                //                                 <div className="font-medium flex items-center">
                //                                     <FaEdit className="mr-2 text-primary" />
                //                                     Modifier
                //                                 </div>
                //                                 <p className="text-sm text-gray-600 mt-1">
                //                                     Pour frets avec statut 'en attente' seulement
                //                                 </p>
                //                             </div>

                //                             <div className="p-1 bg-white rounded">
                //                                 <div className="font-medium flex items-center">
                //                                     <FaSearch className="mr-2 text-info" />
                //                                     Détails complets
                //                                 </div>
                //                                 <p className="text-sm text-gray-600 mt-1">
                //                                     Affiche quotas et liste des camions assignés
                //                                 </p>
                //                             </div>

                //                             <div className="p-1 bg-white rounded">
                //                                 <div className="font-medium flex items-center">
                //                                     <FaTrash className="mr-2 text-danger" />
                //                                     Supprimer
                //                                 </div>
                //                                 <p className="text-sm text-gray-600 mt-1">
                //                                     Pour frets 'en attente' seulement (action irréversible)
                //                                 </p>
                //                             </div>

                //                             <div className="p-1 bg-white rounded">
                //                                 <div className="font-medium flex items-center">
                //                                     <FaCogs className="mr-2 text-secondary" />
                //                                     Réservation de transport
                //                                 </div>
                //                                 <p className="text-sm text-gray-600 mt-1">
                //                                     Spécifier types et nombres de camions nécessaires
                //                                 </p>
                //                             </div>

                //                             <div className="p-1 bg-white rounded">
                //                                 <div className="font-medium flex items-center">
                //                                     <FaTruck className="mr-2 text-dark" />
                //                                     Assigner
                //                                 </div>
                //                                 <p className="text-sm text-gray-600 mt-1">
                //                                     Assignation automatique des camions disponibles
                //                                 </p>
                //                             </div>
                //                         </div>
                //                         <img
                //                             src={ToursFretActionsImg}
                //                             alt="Menu des actions disponibles"
                //                             className="img-fluid mt-4 border rounded-lg shadow-sm"
                //                         />
                //                     </div>
                //                 </div>
                //             </div>

                //             {/* Section 2: Nouvelle Déclaration */}
                //             <div className="">
                //                 <h5 className="font-bold text-xl mb-4 flex items-center text-green-700">
                //                     <FaPlusCircle className="mr-3 text-green-600" />
                //                     2. Création d'une Nouvelle Déclaration
                //                 </h5>
                //                 <img
                //                     src={ToursFretNouveauImg}
                //                     alt="Formulaire de création de fret"
                //                     className="img-fluid mb-4 border rounded-lg shadow-sm"
                //                 />

                //                 <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                //                     <div>
                //                         <h6 className="font-semibold mb-2">Champs obligatoires</h6>
                //                         <ul className="list-disc pl-5 space-y-2 text-gray-700">
                //                             <li><strong>Référence</strong> : Code unique du fret</li>
                //                             <li><strong>Type de fret</strong> : National ou International</li>
                //                             <li><strong>Bailleur</strong> : Client demandeur</li>
                //                             <li><strong>Destinataire</strong> : Client final</li>
                //                             <li><strong>Trajet</strong> : Villes de départ et arrivée</li>
                //                             <li><strong>Dates</strong> : Période de transport</li>
                //                             <li><strong>Nature marchandise</strong> : Type de cargaison</li>
                //                         </ul>
                //                     </div>

                //                     <div className="mb-3 p-2 bg-yellow-50 border-l-4 border-yellow-400 rounded">
                //                         <FaExclamationTriangle className="inline mr-2 text-yellow-500" />
                //                         Le statut initial est 'en attente'. Une réservation est nécessaire avant toute assignation.
                //                     </div>
                //                 </div>
                //             </div>

                //             {/* Section 3: Réservation de Transport */}
                //             <div className="">
                //                 <h5 className="font-bold text-xl mb-4 flex items-center text-purple-700">
                //                     <FaCogs className="mr-3 text-purple-500" />
                //                     3. Réservation de Transport
                //                 </h5>
                //                 <img
                //                     src={ToursFretModifierImg}
                //                     alt="Interface de réservation"
                //                     className="img-fluid mb-4 border rounded-lg shadow-sm"
                //                 />

                //                 <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                //                     <div>
                //                         <h6 className="font-semibold mb-3">Processus en 2 étapes</h6>
                //                         <ol className="list-decimal pl-5 space-y-3">
                //                             <li>
                //                                 <strong>Spécificités</strong>
                //                                 <ul className="list-disc pl-5 mt-1 text-sm text-gray-600 space-y-1">
                //                                     <li>Sélection des types de camions</li>
                //                                     <li>Définition du nombre de camions par type</li>
                //                                     <li>Spécification de la charge utile par camion</li>
                //                                 </ul>
                //                             </li>
                //                             <li>
                //                                 <strong>Quotas (frets internationaux)</strong>
                //                                 <ul className="list-disc pl-5 mt-1 text-sm text-gray-600 space-y-1">
                //                                     <li>Répartition par source (nationaux/internationaux)</li>
                //                                     <li>Vérification de la cohérence des quotas</li>
                //                                 </ul>
                //                             </li>
                //                         </ol>
                //                     </div>

                //                     <div>
                //                         <h6 className="font-semibold mb-3">Règles de validation</h6>
                //                         <ul className="list-disc pl-5 space-y-1 text-gray-700">
                //                             <li>Charge utile -- 0 pour tous les types</li>
                //                             <li>Nombre de camions -- 0 pour chaque type</li>
                //                             <li>Pour les frets internationaux : somme des quotas = nombre total</li>
                //                             <li>Modification possible avant toute assignation</li>
                //                         </ul>

                //                         <div className="mb-3 bg-blue-50 border-l-4 border-blue-400 rounded">
                //                             <FaInfoCircle className="inline mr-2 text-blue-500" />
                //                             <strong>Automatisation :</strong> Le système tente d'assigner automatiquement les camions après réservation.
                //                         </div>
                //                     </div>
                //                 </div>
                //             </div>

                //             {/* Section 4: Modification */}
                //             <div className="">
                //                 <h5 className="font-bold text-xl mb-4 flex items-center text-orange-700">
                //                     <FaEdit className="mr-3 text-orange-500" />
                //                     4. Modification d'une Déclaration
                //                 </h5>

                //                 <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                //                     <div>
                //                         <h6 className="font-semibold mb-1">Conditions</h6>
                //                         <ul className="list-disc pl-5 space-y-2 text-gray-700">
                //                             <li>Statut doit être 'en attente' pour modifier les informations de base</li>
                //                             <li>Réservation modifiable avant toute assignation</li>
                //                             <li>Certains champs verrouillés après validation</li>
                //                             <li>Modification des quotas possible si statut 'reservee'</li>
                //                         </ul>
                //                     </div>

                //                     <div>
                //                         <h6 className="font-semibold mb-1">Processus</h6>
                //                         <ol className="list-decimal pl-5 space-y-2 text-gray-700">
                //                             <li>Localiser le fret dans la liste</li>
                //                             <li>Cliquer sur "⋮" puis "Modifier"</li>
                //                             <li>Apporter les modifications nécessaires</li>
                //                             <li>Valider les changements</li>
                //                         </ol>
                //                     </div>
                //                 </div>

                //                 <div className="mt-4 grid grid-cols-1 md:grid-cols-2 gap-4">
                //                     <div className="p-3 bg-red-50 border-l-4 border-red-400 rounded">
                //                         <FaExclamationCircle className="inline mr-2 text-red-500" />
                //                         Toute modification après assignation peut nécessiter une réassignation des camions.
                //                     </div>
                //                     <div className="p-3 bg-green-50 border-l-4 border-green-400 rounded">
                //                         <FaInfoCircle className="inline mr-2 text-green-500" />
                //                         <strong>Visualisation :</strong> Les quotas restants se mettent à jour immédiatement après modification.
                //                     </div>
                //                 </div>
                //             </div>
                //         </div>
                //     )
                // }
            ]
        }
    ];

    const [showMobileMenu, setShowMobileMenu] = useState(false);

    const getActiveContent = () => {
        const module = modules.find(m => m.id === activeModule);
        if (!module) return null;

        // Afficher toujours le contenu direct du module s'il existe
        if (module.content) return module.content;

        // Si le module a des sections mais qu'elles sont fermées, afficher la première section quand même
        if (module.sections?.length > 0) {
            const sectionToShow = activeSection || module.sections[0].id;
            return (
                <div>
                    {module.sections.map(section => (
                        <div
                            key={section.id}
                            id={`section-${section.id}`}
                            className="mb-8"
                        >
                            {sectionToShow === section.id && section.content}
                        </div>
                    ))}
                </div>
            );
        }

        return null;
    };

    return (
        <div id="wrapper">
            <Sidebar user_id={user_id} />
            <div id="page-wrapper" className="gray-bg">
                <Navbar />
                <div>
                    <div className="row wrapper border-bottom white-bg page-heading">
                        <div className="col-lg-12">
                            <h2 className="d-flex align-items-center">
                                <FaBook size={25} className="mr-2" />
                                Manuel d'utilisation
                            </h2>
                            <div className="">
                                <small>
                                    Ce manuel explique les fonctionnalités principales de l'application TransportPro.
                                </small>
                            </div>

                            <small id='hbreadcrumb' className='d-flex justify-content-end'>
                                <ol className="breadcrumb">
                                    <li className="breadcrumb-item custom-breadcrumb-item">
                                        <Link to={`/Menu`}> Accueil</Link>
                                    </li>
                                    <li className="breadcrumb-item">
                                        Manuel d'utilisation
                                    </li>
                                </ol>
                            </small>
                        </div>
                    </div>

                    <div className="wrapper wrapper-content animated fadeInRight mt-3">
                        <div className="row">
                            <div className="col-lg-12">
                                <div style={{
                                    display: 'flex',
                                    flexDirection: 'row',
                                    gap: '10px',
                                    marginBottom: '10px',
                                    flexWrap: 'wrap'
                                }}>
                                    <Button
                                        variant="secondary"
                                        onClick={() => navigate(-1)}
                                        style={{ padding: '5px 10px' }}
                                    >
                                        <FaArrowLeft className="me-1" /> Retour
                                    </Button>

                                    {/* Bouton menu mobile */}
                                    <Button
                                        variant="primary"
                                        onClick={() => setShowMobileMenu(!showMobileMenu)}
                                        style={{
                                            padding: '5px 10px',
                                            display: window.innerWidth < 992 ? 'block' : 'none'
                                        }}
                                    >
                                        <FaBars className="me-1" /> Menu
                                    </Button>
                                </div>

                                <div className="ibox">
                                    <div className="ibox-content">
                                        <div style={{
                                            display: 'flex',
                                            flexDirection: window.innerWidth < 992 ? 'column' : 'row',
                                            gap: '20px'
                                        }}>
                                            {/* Menu latéral */}
                                            <div style={{
                                                width: window.innerWidth < 992 ? '100%' : '250px',
                                                // maxHeight: '650px',
                                                // overflowY: 'auto',
                                                display: window.innerWidth < 992 ? (showMobileMenu ? 'block' : 'none') : 'block',
                                                position: window.innerWidth < 992 ? 'relative' : 'sticky',
                                                top: '20px',
                                                alignSelf: 'flex-start'
                                            }}>
                                                <div className="list-group list-group-flush">
                                                    {modules.map(module => (
                                                        <div key={module.id} style={{ marginBottom: '5px' }}>
                                                            <button
                                                                onClick={() => {
                                                                    setActiveModule(module.id);
                                                                    if (module.sections) {
                                                                        toggleSection(module.id);
                                                                    } else {
                                                                        setActiveSection(null);
                                                                    }
                                                                    if (window.innerWidth < 992) {
                                                                        setShowMobileMenu(false);
                                                                    }
                                                                }}
                                                                style={{
                                                                    width: '100%',
                                                                    textAlign: 'left',
                                                                    padding: '12px',
                                                                    border: 'none',
                                                                    background: 'transparent',
                                                                    fontWeight: activeModule === module.id ? '600' : '400',
                                                                    color: '#333',
                                                                    fontSize: '1rem',
                                                                    display: 'flex',
                                                                    alignItems: 'center'
                                                                }}
                                                            >
                                                                {module.icon}
                                                                <span style={{ marginLeft: '8px', marginRight: '4px' }}>{module.name}</span>
                                                                {/* {module.sections && (
                                                                    <span style={{ marginLeft: 'auto' }}>
                                                                        {openSections[module.id] ? <FaChevronUp size={12} /> : <FaChevronDown size={12} />}
                                                                    </span>
                                                                )} */}
                                                                {module.sections && module.sections.length > 0 && (
                                                                    <span className="ms-auto">
                                                                        {openSections[module.id] ? <FaChevronUp size={12} /> : <FaChevronDown size={12} />}
                                                                    </span>
                                                                )}
                                                            </button>

                                                            {module.sections && openSections[module.id] && module.sections.map(section => (
                                                                <button
                                                                    key={section.id}
                                                                    onClick={() => {
                                                                        setActiveModule(module.id);
                                                                        setActiveSection(section.id);
                                                                        if (window.innerWidth < 992) {
                                                                            setShowMobileMenu(false);
                                                                        }
                                                                    }}
                                                                    style={{
                                                                        width: '100%',
                                                                        textAlign: 'left',
                                                                        padding: '8px 8px 8px 40px',
                                                                        fontSize: '0.95rem',
                                                                        fontWeight: activeSection === section.id ? '600' : '400',
                                                                        color: activeSection === section.id ? '#1a365d' : '#333',
                                                                        border: 'none',
                                                                        background: 'transparent'
                                                                    }}
                                                                >
                                                                    {section.name}
                                                                </button>
                                                            ))}
                                                        </div>
                                                    ))}
                                                </div>
                                            </div>

                                            {/* Contenu principal */}
                                            <div style={{
                                                flex: 1,
                                                padding: '16px',
                                                marginLeft: window.innerWidth < 992 ? '0' : '20px',
                                                maxWidth: '100%',
                                                overflowX: 'hidden'
                                            }}>
                                                <div className="prose max-w-none">
                                                    {getActiveContent()}
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="footer text-center">
                        <Footer />
                    </div>
                </div>
            </div>
        </div>
    );
};

export default ManuelUtilisation;